<template>
  <div class="mindmap">
    <div class="nav-menu" v-show="showAvatarMenu">
      <div class="nav-title">{{ profile.name }}</div>
      <div class="nav-item" @click="logout">{{ $t("mindmap.logout") }}</div>
    </div>

    <!--貼上markdown(僅自編模式可用)-->
    <BaseModal :visible="showPasteMDForm" :title="$t('mindmap.mainMenu.pasteMD')" :confirm-text="$t('mindmap.確定')"
      :can-confirm="pasteMDText.length !== 0" @close="showPasteMDForm = false" @confirm="pasteMD()">
      <div class="rename-wrap">
        <label class="rename-bar">
          <textarea :placeholder="$t('mindmap.markDownNote')" v-model="pasteMDText" />
          <div class="delete-btn" v-show="pasteMDText.length !== 0" @click="resetPasteMDText()">
            <svg-icon icon-class="close" />
          </div>
        </label>
      </div>
    </BaseModal>

    <!--輸入編輯密鑰-->
    <BaseModal :visible="showEditKeyForm" :title="$t('mindmap.inputEditKey')" :confirm-text="$t('mindmap.確定')"
      :can-confirm="userInputKey !== ''" @close="showEditKeyForm = false" @confirm="confirmToCheckKey()">
      <div class="rename-wrap">
        <label class="rename-bar">
          <input :placeholder="$t('mindmap.sixBit')" v-model="userInputKey" maxlength="6" type="password" />
          <div class="delete-btn" v-show="userInputKey.length !== 0" @click="resetUserInputKey()">
            <svg-icon icon-class="close" />
          </div>
        </label>
      </div>
    </BaseModal>

    <div v-show="showShareLinkBox && !showQRCodeCard" class="shareCard-wrap">
      <div class="shareCard shareCard-large-padding">
        <div class="close-btn"><svg-icon iconClass="close" @click="closeShareLinkBox()"></svg-icon></div>
        <div class="rename-wrap">
          <label class="rename-bar">
            <input :placeholder="currentMindMapInfo.mindmapName" v-model="titleEditVal" maxlength="20" />
            <div class="delete-btn"
              v-show="titleEditVal.length !== 0 && titleEditVal !== currentMindMapInfo.mindmapName"
              @click="resetTitleEdit()">
              <svg-icon icon-class="close" />
            </div>
          </label>
        </div>

        <div v-show="currentMindMapInfo.openCowork" class="url-wrap"><span class="url-title">URL：</span>{{ shortURLHost
          }}<span class="short-url">{{
            currentMindMapURL }}</span>
          <span class="copy-btn" @click="copyShortUrl()"><svg-icon icon-class="copy" /></span>
          <span class="copy-btn" @click="openQRCode(shortURLHost + currentMindMapURL, currentMindMapURL)"><svg-icon icon-class="qrcode-new" /></span>
          <span v-if="shouldShowPushButton" class="push-button"
                                :class="{ 'disabled': isSendDisabled }"
                                @click="handleSendClick()">
             <svg-icon icon-class="upload" class="sendweb-icon" />
          </span>
        </div>
        <div class="cowork-mode">
          <div class="cowork-mode-title">{{ $t("mindmap.mindmapHome.haveLinkCanDo") }}</div>
          <SelectMenu :category="coworkModeCate"
            :defaultSelect="$t('mindmap.mindmapHome.coworkModeNoteText.viewLongVer')" ref="coworkModeSelect"
            class="cowork-mode-select" />
          <div v-show="currentMindMapInfo.openCowork && showSaveCoworkBtn" class="save-btn" @click="saveCoworkMode()">
            {{ $t("mindmap.mindmapHome.save") }}
          </div>
          <div v-show="currentMindMapInfo.openCowork" class="save-btn gray-btn" @click="closeOpenCowork()">
            {{ $t("mindmap.mindmapHome.closeShare") }}
          </div>
          <div v-show="!currentMindMapInfo.openCowork" @click="setOpenCowork()" class="save-btn">
            {{ $t("mindmap.mindmapHome.publishShare") }}
          </div>
        </div>
        <div class="save-btn template-btn" @click="publishAsAssignmentTemplate()">
            {{ $t("mindmap.mindmapHome.publishAsAssignmentTemplate") }}
          </div>
      </div>
    </div>

    <div class="main-menu" v-show="showMainMenu">
      <!-- <div class="nav-item" @click="backToHome" v-show="isLogin">{{ $t("mindmap.mainMenu.gotoHome") }}</div> -->
      <div class="nav-item" @click="openRenameBox()" v-show="isCreator">{{ $t("mindmap.mainMenu.rename") }}</div>
      <div class="nav-item" v-if="isLogin && selfEditMode" @click="triggerInputMD">{{ $t("mindmap.mainMenu.inputMD") }}
      </div>
      <div class="nav-item" v-if="isLogin && selfEditMode" @click="triggerPasteMD">{{ $t("mindmap.mainMenu.pasteMD") }}
      </div>
      <div class="nav-item" @click="downloadImg">{{ $t("mindmap.mainMenu.downloadImage") }}</div>
      <div class="nav-item" @click="copyMD">{{ $t("mindmap.mainMenu.copyMD") }}</div>
      <div class="nav-item" @click="downloadMD">{{ $t("mindmap.mainMenu.downloadMD") }}</div>
      <div class="nav-item" v-show="isCreator" @click="exportStaticMindmap" >{{ $t("mindmap.mainMenu.exportStaticMindmap") }}</div>
      <div class="nav-item-phone" @click="showMemberList=true">{{ $t("mindmap.currentUser") }}</div>
    </div>

    <!--匿名登入命名窗-->
    <BaseModal :visible="showAnonymousNameBox" 
      :title="$t('mindmap.anonymousNameBox.title')"
      :welcome-title="$t('mindmap.anonymousNameBox.welcomeTitle')"
      :or-text="$t('mindmap.anonymousNameBox.or')"
      :login-text="$t('mindmap.anonymousNameBox.loginHint')"
      :confirm-text="$t('mindmap.anonymousNameBox.save')" 
      :can-confirm="anonymousTempName.length !== 0"
      :show-close="false" 
      :is-anonymous-login="true"
      @confirm="saveAnonymousName()"
      @login="loginTMID()">
      <div class="rename-wrap">
        <label class="rename-bar">
          <input :placeholder="$t('mindmap.anonymousNameBox.placeholder')" v-model="anonymousTempName" maxlength="10" />
          <div class="delete-btn" v-show="anonymousTempName.length !== 0" @click="resetAnonymousName()">
            <svg-icon icon-class="close" />
          </div>
        </label>
      </div>
    </BaseModal>

    <!--重新命名-->
    <BaseModal :visible="showRenameBox" :title="$t('mindmap.renameBox.title')"
      :confirm-text="$t('mindmap.renameBox.save')"
      :can-confirm="renameVal && renameVal.length !== 0 && renameVal !== currentMindmapName" @close="closeRenameBox()"
      @confirm="saveRename()">
      <div class="rename-wrap">
        <label class="rename-bar">
          <input :placeholder="currentMindmapName" v-model="renameVal" maxlength="20" />
          <div class="delete-btn" v-show="renameVal && renameVal.length !== 0" @click="resetRename()">
            <svg-icon icon-class="close" />
          </div>
        </label>
      </div>
    </BaseModal>
    <div v-show="!showForbidden && !showRefreshHint">
      <q-dialog v-model="showImgEditor" id="mindmap-img-editor" persistent>
        <mind-map-img-editor />
      </q-dialog>

      <!-- 靜態心智圖 URL 對話框 -->
      <div v-show="showStaticUrlDialog && !showQRCodeCard" class="shareCard-wrap">
        <div class="shareCard shareCard-large-padding">
          <div class="close-btn"><svg-icon iconClass="close" @click="showStaticUrlDialog = false"></svg-icon></div>
          <div class="shareCard-title">{{ currentMindmapName }}</div>
          <div class="url-wrap">
            <span class="url-title">{{ $t("mindmap.staticMindmap.urlLabel") }}</span>{{ shortURLHost
            }}<span class="short-url">{{ currentMindmapStaticCode }}</span>
            <span class="copy-btn" @click="copyStaticUrl"><svg-icon icon-class="copy" /></span>
            <span class="copy-btn" @click="openQRCode(shortURLHost + currentMindmapStaticCode, currentMindmapStaticCode)"><svg-icon icon-class="qrcode-new" /></span>
          </div>
        </div>
      </div>

      <div v-show="selfEditMode && !showNotAllowView || (!selfEditMode && coworkMode == 'view' && isCreator)"
        class="coworkmode-badge">
        <svg-icon icon-class="hi-mind" class="hi-mind-icon"></svg-icon>
        <div class="hamburger-btn" @click="showMainMenu = !showMainMenu"><svg-icon icon-class="hamburger"
            class="hamburger-icon" /></div>
        <div class="home-btn" v-if="isLogin" @click="backToHome()"><svg-icon icon-class="home2" class="home-icon" />
        </div>
        <span v-if="isInCollect" @click="backCollect()">
          <svg-icon v-show="collectIdType === 'task'" icon-class="task" class="task-icon" />
          <svg-icon v-show="collectIdType !== 'task'" icon-class="folder" class="folder-icon" />
        </span><span class="file-name" @click="openShareLinkBox()">{{ displayMindmapName }}<span v-if="isUserLimitReached" class="user-limit-indicator">{{ $t("mindmap.userLimitReached") }}</span></span>
      </div>
      <div v-show="!selfEditMode && coworkMode == 'edit' && !showNotAllowView" class="coworkmode-badge">
        <svg-icon icon-class="hi-mind" class="hi-mind-icon"></svg-icon>
        <div class="hamburger-btn" @click="showMainMenu = !showMainMenu"><svg-icon icon-class="hamburger"
            class="hamburger-icon" /></div>
        <div class="home-btn" v-if="isLogin" @click="backToHome()"><svg-icon icon-class="home2" class="home-icon" />
        </div>
        <span v-if="isInCollect" @click="backCollect()" class="folder-btn">
          <svg-icon v-show="collectIdType === 'task'" icon-class="task" class="task-icon" />
          <svg-icon v-show="collectIdType !== 'task'" icon-class="folder" class="folder-icon" />
        </span><span class="file-name" @click="openShareLinkBox()">{{ displayMindmapName }}<span v-if="isUserLimitReached" class="user-limit-indicator">{{ $t("mindmap.userLimitReached") }}</span></span>
      </div>
      <div v-show="!selfEditMode && coworkMode == 'view' && !isCreator && !showNotAllowView" class="coworkmode-badge">
        <svg-icon icon-class="hi-mind" class="hi-mind-icon"></svg-icon>
        <div class="hamburger-btn" @click="showMainMenu = !showMainMenu"><svg-icon icon-class="hamburger"
            class="hamburger-icon" /></div>
        <div class="home-btn" v-if="isLogin" @click="backToHome()"><svg-icon icon-class="home2" class="home-icon" />
        </div>
        <span v-if="isInCollect" @click="backCollect()" class="folder-btn">
          <svg-icon v-show="collectIdType === 'task'" icon-class="task" class="task-icon" />
          <svg-icon v-show="collectIdType !== 'task'" icon-class="folder" class="folder-icon" />
        </span>
        <span class="file-name" @click="openShareLinkBox()">{{ displayMindmapName }}</span>
      </div>


      <!--手機版的工具列-->
      <div class="mindmap-phone-nav">
        <!---上排-->
        <div class="mindmap-phone-nav-top">
          <div v-show="selfEditMode && !showNotAllowView || (!selfEditMode && coworkMode == 'view' && isCreator)" class="left-info">
            <svg-icon icon-class="hi-mind" class="hi-mind-icon"></svg-icon>
            <div class="hamburger-btn" @click="showMainMenu = !showMainMenu"><svg-icon icon-class="hamburger"
                class="hamburger-icon" /></div>
            <div class="home-btn" v-if="isLogin" @click="backToHome()"><svg-icon icon-class="home2" class="home-icon" />
            </div>
            <span v-if="isInCollect" @click="backCollect()">
              <svg-icon v-show="collectIdType === 'task'" icon-class="task" class="task-icon" />
              <svg-icon v-show="collectIdType !== 'task'" icon-class="folder" class="folder-icon" />
            </span><span class="file-name" @click="openShareLinkBox()">{{ displayMindmapName }}<span v-if="isUserLimitReached" class="user-limit-indicator">{{ $t("mindmap.userLimitReached") }}</span></span>
          </div>
          <div v-show="!selfEditMode && coworkMode == 'edit' && !showNotAllowView" class="left-info">
            <svg-icon icon-class="hi-mind" class="hi-mind-icon"></svg-icon>
            <div class="hamburger-btn" @click="showMainMenu = !showMainMenu"><svg-icon icon-class="hamburger"
                class="hamburger-icon" /></div>
            <div class="home-btn" v-if="isLogin" @click="backToHome()"><svg-icon icon-class="home2" class="home-icon" />
            </div>
            <span v-if="isInCollect" @click="backCollect()" class="folder-btn">
              <svg-icon v-show="collectIdType === 'task'" icon-class="task" class="task-icon" />
              <svg-icon v-show="collectIdType !== 'task'" icon-class="folder" class="folder-icon" />
            </span><span class="file-name" @click="openShareLinkBox()">{{ displayMindmapName }}<span v-if="isUserLimitReached" class="user-limit-indicator">{{ $t("mindmap.userLimitReached") }}</span></span>
          </div>
          <div v-show="!selfEditMode && coworkMode == 'view' && !isCreator && !showNotAllowView" class="left-info">
            <svg-icon icon-class="hi-mind" class="hi-mind-icon"></svg-icon>
            <div class="hamburger-btn" @click="showMainMenu = !showMainMenu"><svg-icon icon-class="hamburger"
                class="hamburger-icon" /></div>
            <div class="home-btn" v-if="isLogin" @click="backToHome()"><svg-icon icon-class="home2" class="home-icon" />
            </div>
            <span v-if="isInCollect" @click="backCollect()" class="folder-btn">
              <svg-icon v-show="collectIdType === 'task'" icon-class="task" class="task-icon" />
              <svg-icon v-show="collectIdType !== 'task'" icon-class="folder" class="folder-icon" />
            </span>
            <span class="file-name" @click="openShareLinkBox()">{{ displayMindmapName }}</span>
          </div>

          <div class="right-info">
            <div v-if="!isLogin" @click="loginTMID()" class="profile-btn">
            <svg-icon iconClass="profile" class="profile-icon" />
          </div>

          <div class="avatar-wrap" v-if="isLogin" @click="showAvatarMenu = !showAvatarMenu"><img class="avatar"
              :src="profile.picture" alt="" /></div>
          </div>
         
        </div>

        <!--下排控制列-->
        <div class="mindmap-phone-nav-bottom">
          <!-- 人數已滿載指示器 (手機版左下角) -->
          <div v-if="isUserLimitReached" class="mobile-user-limit-indicator">
            {{ $t("mindmap.userLimitReached") }}
          </div>
          <!--mindMap 工具按鈕-->
          <div class="mindmap-tool" v-if="!isInCollect">
          
            <div class="share-btn" v-show="!showNotAllowView">
              <span class="btn-left"
                :class="{ 'border-right': (!selfEditMode && coworkMode == 'edit' && !showNotAllowView) || (!selfEditMode && coworkMode == 'view' && !isCreator && !showNotAllowView) }"
                v-if="isCreator" @click="openShareLinkBox()"><svg-icon iconClass="link" class="link-icon" />{{
      $t("mindmap.mainMenu.coworkMode") }}</span>
              <span class="badge-inner" v-if="!selfEditMode && coworkMode == 'edit' && !showNotAllowView">{{
      $t("mindmap.coworkMode.edit") }}</span>
              <span class="badge-inner"
                v-if="!selfEditMode && coworkMode == 'view' && !isCreator && !showNotAllowView">{{
      $t("mindmap.coworkMode.view")
    }}</span>

              <!-- 非擁有者顯示簡碼，點擊複製 -->
              <span class="btn-left border-left" v-if="!isCreator && currentMindMapURL && !selfEditMode && coworkMode == 'edit'" @click="copyShortUrl()">
                <svg-icon iconClass="link" class="link-icon" />{{ currentMindMapURL }}
              </span>
            </div>

            <!-- 注音開關 -->
            <div class="phonetic-switch" v-show="isZHTW">
              <div class="scale-switch-click-area"></div>
              <label class="mindmap-switch">
                <span class="mindmap-switch-title">注音</span>
                <input id="phonetic" type="checkbox" v-model="isPhonetic" />
                <span class="mindmap-slider round"></span>
              </label>
            </div>

            <div @click="relayout()" class="controls refresh-btn" v-if="!showNotAllowView">
              <svg-icon iconClass="refresh" />
            </div>


          </div>
          <!--mindMap 工具按鈕(收集區的模式)-->
          <div class="mindmap-tool-collect" v-if="isInCollect">
          
            <div class="share-btn" v-show="!showNotAllowView">
              <span class="btn-left"
                :class="{ 'border-right': (!selfEditMode && coworkMode == 'edit' && !showNotAllowView) || (!selfEditMode && coworkMode == 'view' && !isCreator && !showNotAllowView) }"
                v-if="isCreator" @click="openShareLinkBox()"><svg-icon iconClass="link" class="link-icon" />{{
      $t("mindmap.mainMenu.coworkMode") }}</span>
              <span class="badge-inner" v-if="!selfEditMode && coworkMode == 'edit' && !showNotAllowView">{{
      $t("mindmap.coworkMode.edit") }}</span>
              <span class="badge-inner"
                v-if="!selfEditMode && coworkMode == 'view' && !isCreator && !showNotAllowView">{{
      $t("mindmap.coworkMode.view")
    }}</span>

              <!-- 非擁有者顯示簡碼，點擊複製 -->
              <span class="btn-left" v-if="!isCreator && currentMindMapURL" @click="copyShortUrl()">
                <svg-icon iconClass="link" class="link-icon" />{{ currentMindMapURL }}
              </span>
            </div>

            <!-- 注音開關 -->
            <div class="phonetic-switch" v-show="isZHTW">
              <div class="scale-switch-click-area"></div>
              <label class="mindmap-switch">
                <span class="mindmap-switch-title">注音</span>
                <input id="phonetic" type="checkbox" v-model="isPhonetic" />
                <span class="mindmap-slider round"></span>
              </label>
            </div>

            <div @click="relayout()" class=" refresh-btn" v-if="!showNotAllowView">
              <svg-icon iconClass="refresh" />
            </div>
            <div
              v-if="isInCollect && coworkMode == 'view' && !isCreator && !showForbiddenCollect && collectIdType === 'task'"
              class="; edit-btn" @click="checkBeforeEdit()">
              <svg-icon iconClass="edit" class="edit-icon" />
            </div>



          </div>
        </div>


      </div>

      <!--協作模式目前所有人完全不會在左上顯示儲存資訊，因為只有組長會存，但組長會彈出儲存訊息-->
      <!-- <div v-show="isModified && showSaveStatus" class="saving-hint" :class="{ 'left-hint': !selfEditMode }">
        偵測變動，等候保存到雲端
      </div>
      <div v-show="!isModified && showSaveStatus" class="saved-hint" :class="{ 'left-hint': !selfEditMode }">已保存</div> -->
      <!-- <div @click="loginTMID()" class="temp-btn" v-if="!isLogin">login</div> -->
      <div class="img-viewer" v-if="showBigImg" @click="clickImg()">
        <img :src="currentViewImg" alt="" />
      </div>
      <div class="addnode-wrap" v-show="showMoveTool">
        <div class="movetool-card">
          <p class="addnode-title-large">{{ $t("mindmap.moveNodeTitle") }}</p>
          <p class="addnode-title-md">{{ $t("mindmap.moveNodeHint") }}</p>
          <div class="card-scroll-area" id="movetool-scroll-area">
            <svg class="connections" xmlns="http://www.w3.org/2000/svg" :style="{ height: drawLineAreaH }">
              <!-- 垂直線 -->
              <line v-for="(line, index) in verticalLines" :key="'v-' + index" :x1="line.x1" :y1="line.y1" :x2="line.x2"
                :y2="line.y2" stroke="gray" stroke-width="2" />
              <!-- 水平線 -->
              <line v-for="(line, index) in horizontalLines" :key="'h-' + index" :x1="line.x1" :y1="line.y1"
                :x2="line.x2" :y2="line.y2" stroke="gray" stroke-width="2" />
            </svg>
            <MindMapTreeMenuVue v-if="treeMenuData != ''" :treeMenuData="treeMenuData" :currentNode="currentNode"
              :depth="0"></MindMapTreeMenuVue>
          </div>
          <div class="addnodebtn-area">
            <div class="addnodebtn-group">
              <div class="addnode-btn" @click="confirmMoveToParent()">{{ $t('mindmap["確定"]') }}</div>
              <div class="addnode-btn" @click="closeMoveTool()">{{ $t('mindmap["取消"]') }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 隱藏的文件輸入 -->
      <input type="file" accept=".md" ref="fileInput" @change="InputMD" style="display: none" />

      <div class="addnode-wrap" v-show="showAddNoteTool">
        <div class="addnode-card-md">
          <p class="addnode-title-large">
            {{ ctrlNodeMode == "add" ? $t("mindmap.新增") : $t("mindmap.編輯") }}
          </p>
          <div class="card-scroll-area">
            <input id="node-text-focus" class="addnode-text small-textarea" v-model="nodeText"
              :placeholder="$t('mindmap.輸入文字')" maxlength="40" />
            <p class="text-length">{{ nodeTextLength }}/40</p>
            <div class="addnode-direction" v-if="isCurrentSelectRoot">
              <div class="addnode-title">{{ $t("mindmap.加入根節點") }}</div>
              <label class="radio-btn" :class="{ 'check-btn': direction === 'left' }"><input type="radio"
                  v-model="direction" value="left" />{{ $t("mindmap.左邊") }}</label>
              <label class="radio-btn" :class="{ 'check-btn': direction === 'right' }"><input type="radio"
                  v-model="direction" value="right" />{{ $t("mindmap.右邊") }}</label>
            </div>
            <div class="addnode-title more-setting-btn" @click="showMoreSetting = !showMoreSetting">
              {{ $t("mindmap.進階設定") }}&nbsp;<span><svg-icon iconClass="arrowdown"
                  :class="{ 'arrowdown-rotate': showMoreSetting }" /></span>
            </div>
            <div class="more-setting" v-show="showMoreSetting">
              <div class="divide-wrap">
                <div class="divide-line" />
              </div>
              <!--色彩編輯-->
              <p class="addnode-title" style="padding-top: 10px">
                {{ $t("mindmap.線條顏色") }}
              </p>
              <div class="q-gutter-sm" style="padding: 10px 0 2px 0">
                <div class="color-btn" :class="{ 'select-color': currentLineColor == item }"
                  :style="{ 'background-color': item }" v-for="(item, index) in lineColorArr" :key="item"
                  v-show="index < 5" @click="setLineColor(item)">
                  <svg-icon class="color-check" v-show="currentLineColor == item" icon-class="check" />
                </div>
              </div>
              <div class="q-gutter-sm" style="padding: 2px 0">
                <div class="color-btn" :class="{ 'select-color': currentLineColor == item }"
                  :style="{ 'background-color': item }" v-for="(item, index) in lineColorArr" :key="item"
                  v-show="index >= 5" @click="setLineColor(item)">
                  <svg-icon class="color-check color-check-white" v-show="currentLineColor == item"
                    icon-class="check" />
                </div>
              </div>

              <p class="addnode-title" style="margin-top: 5px">
                {{ $t("mindmap.節點顏色") }}
              </p>
              <div class="q-gutter-sm" style="padding: 10px 0 2px 0">
                <div class="color-btn" :class="{ 'select-color': currentNodeColor == item }"
                  :style="{ 'background-color': item }" v-show="index < 4" v-for="(item, index) in nodeColorArr"
                  :key="index + 'sticker'" @click="setNodeColor(item)">
                  <svg-icon class="color-check" v-show="currentNodeColor == item" icon-class="check" />
                </div>
              </div>
              <div class="divide-wrap">
                <div class="divide-line" />
              </div>
              <!--圖片編輯-->
              <div class="addnode-title">{{ $t("mindmap.圖片") }}</div>
              <div class="btn-group-init">
                <label class="btn" v-show="currentImgUrl == ''">
                  <svg-icon icon-class="add_imgbgc2" class="draw-icon img_upload-icon" />
                  <input ref="mainImageUploaderInit" type="file" accept="image/JPEG,image/png"
                    @change="imgfileChangeHandler" @click="resetImageUploader" name="img-upload"
                    class="img-upload-input" />
                </label>
                <div class="btn" v-show="currentImgUrl == ''" @click="openWhiteEditor()">
                  <svg-icon icon-class="draw-initial" class="draw-icon draw-icon-small" />
                </div>
              </div>

              <p v-show="isOverMaxImageSize" class="warning-text">{{ $t("mindmap.圖片過大提示字1") }}&nbsp;{{
                `${maxImageSize}${$t("mindmap.圖片過大提示字2")}` }}</p>
              <div class="uploader-wrap" v-show="currentImgUrl != ''">
                <div class="uploader">
                  <img class="uploader-img" :src="currentImgUrl" alt="" @click="openEditor()" />
                </div>
              </div>
              <div class="btn-group-under" v-show="currentImgUrl != ''">
                <label class="btn">
                  <svg-icon icon-class="add_imgbgc2" class="img_upload-icon" />
                  <input ref="mainImageUploader" type="file" accept="image/JPEG,image/png"
                    @change="imgfileChangeHandler" @click="resetImageUploader" name="img-upload"
                    class="img-upload-input" />
                </label>
                <div class="btn btn-canvas" v-show="currentImgUrl != ''" @click="openWhiteEditor()">
                  <svg-icon icon-class="draw-initial" class="draw-icon draw-icon-small" />
                </div>
                <div class="btn btn-close" @click="currentImgUrl = ''">
                  <svg-icon icon-class="close" class="close-icon" />
                </div>
              </div>

              <div class="divide-wrap">
                <div class="divide-line" />
              </div>
              <!--連結編輯-->
              <div>
                <div class="addnode-title">{{ $t("mindmap.連結") }}</div>
                <textarea class="addnode-text small-textarea" v-model="nodeTextURL"
                  :placeholder="$t('mindmap.輸入URL')"></textarea>
              </div>
              <div class="divide-wrap">
                <div class="divide-line" />
              </div>
              <!--註解編輯-->
              <div>
                <div class="addnode-title">{{ $t("mindmap.註解") }}</div>
                <textarea class="addnode-text" v-model="nodeTextNote" :placeholder="$t('mindmap.輸入文字')"
                  maxlength="100"></textarea>
                <p class="text-length">{{ nodeTextNoteLength }}/100</p>
              </div>
            </div>
          </div>
          <div class="addnodebtn-area" v-show="!isUploadImg">
            <div class="addnode-warning" v-show="ctrlNodeMode == 'edit' && !isCurrentNodePreEditByMe">{{
              $t("mindmap.preEditHint") + "\n" + nodeEditBy.name + "\n" + $t("mindmap.confirmUpdate") }}</div>
            <div class="addnodebtn-group">
              <div class="addnode-btn" @click="confirm()">{{ $t('mindmap["確定"]') }}</div>
              <div class="addnode-btn" @click="showAddNoteTool = false">{{ $t('mindmap["取消"]') }}</div>
            </div>
          </div>
        </div>

        <div class="addnode-card-lg">
          <p class="addnode-title-large">
            {{ ctrlNodeMode == "add" ? $t("mindmap.新增") : $t("mindmap.編輯") }}
          </p>
          <div class="card-scroll-area">
            <input id="node-text-focus-large" class="addnode-text small-textarea" v-model="nodeText"
              :placeholder="$t('mindmap.輸入文字')" maxlength="40" />
            <p class="text-length">{{ nodeTextLength }}/40</p>
            <div class="addnode-direction" v-if="isCurrentSelectRoot">
              <div class="addnode-title">{{ $t("mindmap.加入根節點") }}</div>
              <label class="radio-btn" :class="{ 'check-btn': direction === 'left' }"><input type="radio"
                  v-model="direction" value="left" />{{ $t("mindmap.左邊") }}</label>
              <label class="radio-btn" :class="{ 'check-btn': direction === 'right' }"><input type="radio"
                  v-model="direction" value="right" />{{ $t("mindmap.右邊") }}</label>
            </div>
            <div class="addnode-title more-setting-btn" @click="showMoreSetting = !showMoreSetting">{{
              $t("mindmap.進階設定") }}&nbsp;<svg-icon iconClass="arrowdown"
                :class="{ 'arrowdown-rotate': showMoreSetting }" /></div>
            <div class="divide-wrap" v-show="showMoreSetting">
              <div class="divide-line" />
            </div>
            <div class="flex-wrap" v-show="showMoreSetting">
              <div class="left-part">
                <div class="img-area">
                  <div class="addnode-title">{{ $t("mindmap.圖片") }}</div>
                  <div class="btn-group-init">
                    <label class="btn btn-upload" v-show="currentImgUrl == ''">
                      <svg-icon icon-class="add_imgbgc2" class="draw-icon img_upload-icon" />
                      <input ref="mainImageUploaderInit" type="file" accept="image/JPEG,image/png"
                        @change="imgfileChangeHandler" @click="resetImageUploader" name="img-upload"
                        class="img-upload-input" />
                    </label>
                    <div class="btn btn-canvas" v-show="currentImgUrl == ''" @click="openWhiteEditor()">
                      <svg-icon icon-class="draw-initial" class="draw-icon draw-icon-small" />
                    </div>
                  </div>

                  <p v-show="isOverMaxImageSize" class="warning-text">{{ $t("mindmap.圖片過大提示字1") }}&nbsp;{{
                    `${maxImageSize}${$t("mindmap.圖片過大提示字2")}` }}</p>
                  <div class="uploader-wrap" v-show="currentImgUrl != ''">
                    <div class="uploader">
                      <img class="uploader-img" :src="currentImgUrl" alt="" @click="openEditor()" />
                    </div>
                  </div>
                  <div class="btn-group-under" v-show="currentImgUrl != ''">
                    <label class="btn">
                      <svg-icon icon-class="add_imgbgc2" class="img_upload-icon" />
                      <input ref="mainImageUploader" type="file" accept="image/JPEG,image/png"
                        @change="imgfileChangeHandler" @click="resetImageUploader" name="img-upload"
                        class="img-upload-input" />
                    </label>
                    <div class="btn btn-canvas" v-show="currentImgUrl != ''" @click="openWhiteEditor()">
                      <svg-icon icon-class="draw-initial" class="draw-icon draw-icon-small" />
                    </div>
                    <div class="btn btn-close" @click="currentImgUrl = ''">
                      <svg-icon icon-class="close" class="close-icon" />
                    </div>
                  </div>
                </div>
                <div class="divide-wrap">
                  <div class="divide-line" />
                </div>
                <div class="addnode-title">{{ $t("mindmap.連結") }}</div>
                <textarea class="addnode-text small-textarea" v-model="nodeTextURL"
                  :placeholder="$t('mindmap.輸入URL')"></textarea>
              </div>
              <div class="right-part">
                <!--色彩編輯-->
                <p class="addnode-title" style="padding-top: 10px">
                  {{ $t("mindmap.線條顏色") }}
                </p>
                <div class="q-gutter-sm" style="padding: 10px 0 2px 0">
                  <div class="color-btn" :class="{ 'select-color': currentLineColor == item }"
                    :style="{ 'background-color': item }" v-for="(item, index) in lineColorArr" :key="item"
                    v-show="index < 5" @click="setLineColor(item)">
                    <svg-icon class="color-check" v-show="currentLineColor == item" icon-class="check" />
                  </div>
                </div>
                <div class="q-gutter-sm" style="padding: 2px 0">
                  <div class="color-btn" :class="{ 'select-color': currentLineColor == item }"
                    :style="{ 'background-color': item }" v-for="(item, index) in lineColorArr" :key="item"
                    v-show="index >= 5" @click="setLineColor(item)">
                    <svg-icon class="color-check color-check-white" v-show="currentLineColor == item"
                      icon-class="check" />
                  </div>
                </div>

                <p class="addnode-title" style="margin-top: 5px">
                  {{ $t("mindmap.節點顏色") }}
                </p>
                <div class="q-gutter-sm" style="padding: 10px 0 2px 0">
                  <div class="color-btn" :class="{ 'select-color': currentNodeColor == item }"
                    :style="{ 'background-color': item }" v-show="index < 4" v-for="(item, index) in nodeColorArr"
                    :key="index + 'sticker'" @click="setNodeColor(item)">
                    <svg-icon class="color-check" v-show="currentNodeColor == item" icon-class="check" />
                  </div>
                </div>
                <div class="divide-wrap">
                  <div class="divide-line" />
                </div>

                <div class="addnode-title">{{ $t("mindmap.註解") }}</div>
                <textarea class="addnode-text" v-model="nodeTextNote" :placeholder="$t('mindmap.輸入文字')"
                  maxlength="100"></textarea>
                <p class="text-length">{{ nodeTextNoteLength }}/100</p>
              </div>
            </div>
          </div>
          <div class="addnodebtn-area" v-show="!isUploadImg">
            <div class="addnode-warning" v-show="ctrlNodeMode == 'edit' && !isCurrentNodePreEditByMe">{{
              $t("mindmap.preEditHint") + "\n" + nodeEditBy.name + "\n" + $t("mindmap.confirmUpdate") }}</div>
            <div class="addnodebtn-group">
              <div class="addnode-btn" @click="confirm()">{{ $t('mindmap["確定"]') }}</div>
              <div class="addnode-btn" @click="showAddNoteTool = false">{{ $t('mindmap["取消"]') }}</div>
            </div>
          </div>
        </div>
      </div>

      <!--mindMap 工具按鈕-->
      <div class="mindmap-tool" v-if="!isInCollect">
        <div class="memberList" :class="{ 'memberList-collect': isInCollect && !isCreator && coworkMode == 'view' }"
          v-if="!selfEditMode" @click="showMemberList = !showMemberList">
          <div class="member" v-show="index < 5" v-for="(member, index) in currentCoworkMemberList" :key="member.key">
            <img class="member-img" :src="getAvatar(member)" />
          </div>
        </div>
        <div class="share-btn" v-show="!showNotAllowView">
          <span class="btn-left"
            :class="{ 'border-right': (!selfEditMode && coworkMode == 'edit' && !showNotAllowView) || (!selfEditMode && coworkMode == 'view' && !isCreator && !showNotAllowView) }"
            v-if="isCreator" @click="openShareLinkBox()"><svg-icon iconClass="link" class="link-icon" />{{
            $t("mindmap.mainMenu.coworkMode") }}</span>
          <span class="badge-inner" v-if="!selfEditMode && coworkMode == 'edit' && !showNotAllowView">{{
            $t("mindmap.coworkMode.edit") }}</span>
          <span class="badge-inner" v-if="!selfEditMode && coworkMode == 'view' && !isCreator && !showNotAllowView">{{
            $t("mindmap.coworkMode.view")
            }}</span>
          <!-- 非擁有者顯示簡碼，點擊複製 -->
          <span class="btn-left border-left"
                v-if="!isCreator && currentMindMapURL && !selfEditMode && coworkMode == 'edit'"
                @click="copyShortUrl()">
            <svg-icon iconClass="link" class="link-icon" />{{ currentMindMapURL }}
          </span>
        </div>

        <!-- 注音開關 -->
        <div class="phonetic-switch" v-show="isZHTW">
          <div class="scale-switch-click-area"></div>
          <label class="mindmap-switch">
            <span class="mindmap-switch-title">注音</span>
            <input id="phonetic" type="checkbox" v-model="isPhonetic" />
            <span class="mindmap-slider round"></span>
          </label>
        </div>

        <div @click="relayout()" class="controls refresh-btn" v-if="!showNotAllowView">
          <svg-icon iconClass="refresh" />
        </div>

        <div v-if="!isLogin" @click="loginTMID()" class="controls profile-btn">
          <svg-icon iconClass="profile" class="profile-icon" />
        </div>

        <div class="avatar-wrap" v-if="isLogin" @click="showAvatarMenu = !showAvatarMenu"><img class="avatar"
            :src="profile.picture" alt="" /></div>
      </div>
      <!--mindMap 工具按鈕(收集區的模式)-->
      <div class="mindmap-tool-collect" v-if="isInCollect">
        <div class="memberList" v-if="!selfEditMode" @click="showMemberList = !showMemberList">
          <div class="member" v-show="index < 5" v-for="(member, index) in currentCoworkMemberList" :key="member.key">
            <img class="member-img" :src="getAvatar(member)" />
          </div>
        </div>
        <div class="share-btn" v-show="!showNotAllowView">
          <span class="btn-left"
            :class="{ 'border-right': (!selfEditMode && coworkMode == 'edit' && !showNotAllowView) || (!selfEditMode && coworkMode == 'view' && !isCreator && !showNotAllowView) }"
            v-if="isCreator" @click="openShareLinkBox()"><svg-icon iconClass="link" class="link-icon" />{{
            $t("mindmap.mainMenu.coworkMode") }}</span>
          <span class="badge-inner" v-if="!selfEditMode && coworkMode == 'edit' && !showNotAllowView">{{
            $t("mindmap.coworkMode.edit") }}</span>
          <span class="badge-inner" v-if="!selfEditMode && coworkMode == 'view' && !isCreator && !showNotAllowView">{{
            $t("mindmap.coworkMode.view")
            }}</span>
          <!-- 非擁有者顯示簡碼，點擊複製 -->
          <span class="btn-left border-left"
                v-if="!isCreator && currentMindMapURL && !selfEditMode && coworkMode == 'edit'"
                @click="copyShortUrl()">
            <svg-icon iconClass="link" class="link-icon" />{{ currentMindMapURL }}
          </span>
        </div>

        <!-- 注音開關 -->
        <div class="phonetic-switch" v-show="isZHTW">
          <div class="scale-switch-click-area"></div>
          <label class="mindmap-switch">
            <span class="mindmap-switch-title">注音</span>
            <input id="phonetic" type="checkbox" v-model="isPhonetic" />
            <span class="mindmap-slider round"></span>
          </label>
        </div>

        <div @click="relayout()" class="controls refresh-btn" v-if="!showNotAllowView">
          <svg-icon iconClass="refresh" />
        </div>
        <div v-if="isInCollect && coworkMode == 'view' && !isCreator && !showForbiddenCollect && collectIdType==='task'"
          class="controls edit-btn" @click="checkBeforeEdit()">
          <svg-icon iconClass="edit" class="edit-icon" />
        </div>

        <div v-if="!isLogin" @click="loginTMID()" class="controls profile-btn">
          <svg-icon iconClass="profile" class="profile-icon" />
        </div>

        <div class="avatar-wrap" v-if="isLogin" @click="showAvatarMenu = !showAvatarMenu"><img class="avatar"
            :src="profile.picture" alt="" /></div>
      </div>


      <!-- <div class="mindmap-tool">
      <div @click="openNode('add')" class="controls"><svg-icon iconClass="add" class="add-icon" /></div>
      <div @click="deleteSelectNode()" class="controls" v-show="!isCurrentSelectRoot"><svg-icon iconClass="minus-pure"
          class="minus-icon" /></div>
      <div @click="copyNode()" v-show="!isCurrentSelectRoot" class="controls"><svg-icon iconClass="copy2" class="copy-icon" /></div>
      <div @click="moveNode('up')" class="controls" v-show="!isCurrentSelectRoot"><svg-icon iconClass="arrowdown"
          class="moveup-icon" /></div>
      <div @click="moveNode('down')" class="controls" v-show="!isCurrentSelectRoot"><svg-icon iconClass="arrowdown"
          class="movedown-icon" /></div>
      <div @click="openNode('edit')" class="controls"><svg-icon iconClass="pencil-alt" /></div>
    </div> -->
      <!--mindMap 工具選單按鈕-->
      <div class="mindmap-menu" :style="{ top: posY + 'px', left: posX + 'px' }" v-show="showNodeMenu">
        <div class="menu-item" @click="openNode('add')">
          <span class="menu-icon-wrap"><svg-icon iconClass="add" class="add-icon" /></span>{{ $t("mindmap.menu.新增") }}
        </div>
        <div class="menu-item" @click="deleteSelectNode()"
          v-show="!isCurrentSelectRoot && isCurrentNodeCanBeDelete && !isCurrentNodeLock">
          <span class="menu-icon-wrap"><svg-icon iconClass="minus-pure" class="minus-icon" /></span>{{
          $t("mindmap.menu.刪除") }}
        </div>
        <div class="menu-item" @click="moveNode('up')" v-show="!isCurrentSelectRoot && isCurrentNodeCanMoveUp">
          <span class="menu-icon-wrap"><svg-icon iconClass="arrowdown" class="moveup-icon" /></span>{{
          $t("mindmap.menu.上移") }}
        </div>
        <div class="menu-item" @click="moveNode('down')" v-show="!isCurrentSelectRoot && isCurrentNodeCanMoveDown">
          <span class="menu-icon-wrap"><svg-icon iconClass="arrowdown" class="movedown-icon" /></span>{{
          $t("mindmap.menu.下移") }}
        </div>

        <div class="menu-item" @click="moveNode('left')" v-show="isCurrentNodeCanMoveRight">

          <span class="menu-icon-wrap"><svg-icon iconClass="arrowdown" class="moveleft-icon" /></span>{{
          $t("mindmap.menu.左移") }}
        </div>
        <div class="menu-item" @click="moveNode('right')" v-show="isCurrentNodeCanMoveLeft">

          <span class="menu-icon-wrap"><svg-icon iconClass="arrowdown" class="moveright-icon" /></span>{{
          $t("mindmap.menu.右移") }}
        </div>

        <div class="menu-item" @click="openMoveTool()" v-show="!isCurrentSelectRoot">
          <span class="menu-icon-wrap"><svg-icon iconClass="moveTo" class="minus-icon" /></span>{{
          $t("mindmap.menu.move") }}
        </div>
        <div class="menu-item" @click="openNode('edit')" v-show="!isCurrentNodeLock">
          <span class="menu-icon-wrap"><svg-icon iconClass="pencil-alt" class="pencil-icon" /></span>{{
          $t("mindmap.menu.編輯") }}
        </div>
        <div class="menu-item" @click="copyNode()" v-show="!isCurrentSelectRoot">
          <span class="menu-icon-wrap"><svg-icon iconClass="copy2" class="copy-icon" /></span>{{ $t("mindmap.menu.複製")
          }}
        </div>
        <div class="menu-item" @click="toggleNodeLock()" :class="{ 'lock-color': isCurrentNodeLock }"
          v-show="isCreator">
          <span class="menu-icon-wrap"><svg-icon :iconClass="isCurrentNodeLock ? 'lock' : 'unlock'"
              :class="isCurrentNodeLock ? 'lock-icon' : 'unlock-icon'" /></span>{{ isCurrentNodeLock ?
          $t("mindmap.menu.unlock") : $t("mindmap.menu.lock") }}
        </div>
        <div class="menu-item lock-color" v-show="isCurrentNodeLock && !isCreator">
          <span class="menu-icon-wrap"><svg-icon iconClass="lock" class="lock-icon" /></span>{{
          $t("mindmap.menu.locked") }}
        </div>
        <div class="menu-item" @click="applyNodeColor()" v-show="isCreator && !isCurrentSelectRoot && isCurrentNodeHasChildren">
          <span class="menu-icon-wrap"><svg-icon iconClass="apply_color" class="text-color apply-color-icon" /></span>{{
          $t("mindmap.menu.applyColor") }}
        </div>
        <div class="menu-item" @click="applyAllRightLayout()" v-show="isCreator && isCurrentSelectRoot">
          <span class="menu-icon-wrap"><svg-icon iconClass="all_right-side" class="all-right-icon" /></span>{{
          $t("mindmap.menu.allRightLayout") }}
        </div>
        <div class="menu-item" @click="applyAllLeftLayout()" v-show="isCreator && isCurrentSelectRoot">
          <span class="menu-icon-wrap"><svg-icon iconClass="all_left-side" class="all-left-icon" /></span>{{
          $t("mindmap.menu.allLeftLayout") }}
        </div>

        <div class="menu-item" @click="expandAllNodes()" v-show="isCreator">
          <span class="menu-icon-wrap"><svg-icon iconClass="expand-all" class="expand-all-icon" /></span>{{
          $t("mindmap.menu.expandAll") }}
        </div>
        <div class="menu-item" @click="collapseAllNodes()" v-show="isCreator">
          <span class="menu-icon-wrap"><svg-icon iconClass="collapse-all" class="collapse-all-icon" /></span>{{
          $t("mindmap.menu.collapseAll") }}
        </div>

        <div v-show="showSelectedNote" class="divide-wrap">
          <div class="divide-line" />
        </div>
        <div v-show="showSelectedNote" class="note-wrap">
          <p class="note-text">{{ nodeTextNote }}</p>
        </div>
        <div class="divide-wrap" v-show="nodeEditBy.id != '' && nodeEditBy.name != ''">
          <div class="divide-line" />
        </div>
        <div class="node-info" v-show="nodeEditBy.id != '' && nodeEditBy.name != ''">
          <span class="dot" />
          <span v-show="!nodeEditBy.seat.startsWith('anonymous-') && nodeEditBy.seat != 'wb'"> {{ nodeEditBy.seat
            }}&nbsp;
          </span>{{ nodeEditBy.name }}
        </div>
      </div>



      <div v-show="showMemberList" class="memberList-wrap">
        <div class="memberList-card">
          <div class="close-btn"><svg-icon iconClass="close" @click="showMemberList = false"></svg-icon></div>
          <div class="memberList-title">{{ $t("mindmap.currentUser") }}</div>
          <div class="member-wrap">
            <div class="member" v-for="member in currentCoworkMemberList" :key="member.key">
              <div>
                <img class="member-img" :src="getAvatar(member)" />
              </div>
              <div>{{ member.index + 1 }}.{{ !member.value.id.startsWith("anonymous-") ? member.value.id : "" }}&nbsp;{{
                member.value.name }}</div>
            </div>
          </div>
        </div>
      </div>

      <div id="jsmind_container" :class="{ 'showPhonetic': isPhonetic }" v-if="!isDeleting"></div>
    </div>
    <div v-show="showForbidden" class="coworkmode-badge">{{ $t("mindmap.privateInfo") }}</div>
    <div v-show="showNotAllowView" class="coworkmode-badge"> {{ $t("mindmap.notAllowViewHint") }}</div>
    <div v-show="showRefreshHint" class="coworkmode-badge">{{ $t("mindmap.refreshHint") }}</div>

    <!-- QR Code Dialog -->
    <QRCodeDialog v-if="showQRCodeCard" :url="qrCodeUrl" :short-code="qrCodeShortCode" :short-u-r-l-host="shortURLHost" @close="closeQRCode" />
  </div>
</template>

<script>
/*eslint-disable*/
import { ref, provide, getCurrentInstance, inject, onMounted, onBeforeUnmount, toRaw, nextTick, computed, watch } from "vue"; //Vue3 composition API
import QRCodeDialog from "./QRCodeDialog.vue";
import api from "@/api";
import confProfile from "@/api/profile.js";
import jwt_decode from "jwt-decode";
import "../api/jsmindlib/jsmind.css";
import * as jsMind from "../api/jsmindlib/jsmind.js";

import jmNodeIconStr from "../api/jsmindlib/jmNodeIconString.js";
import SvgIcon from "./SvgIcon.vue";
import MindMapImgEditor from "./MindMapImgEditor.vue";
import MindMapTreeMenuVue from "./MindMapTreeMenu.vue";
import SelectMenu from "./SelectMenu.vue";
import BaseModal from "./BaseModal.vue";
import { QDialog } from "quasar";
import { useRoute, useRouter } from "vue-router";
import { AzureClient } from "@fluidframework/azure-client";
import * as htmlToImage from "html-to-image";
import md from "../api/jsmindlib/mdToJsMind.js";
import { useMindMapFluidSync } from "@/composable/useMindMapFluidSync";
import { useMindMapBlob } from "@/composable/useMindMapBlob";
import { useAssignmentTaskCreator } from "@/composable/useAssignmentTaskCreator";
import { useQuasar } from "quasar";
import CryptoJS from "crypto-js";
import { jsFn } from "@/utils/jsFn";

window.jsMind = jsMind;
// 檢測是否為觸控設備，特別針對 iPad 和其他平板設備
const isTouchDevice = () => {
  // 檢查是否為 iOS 設備 (包括 iPad)
  const isIOS = (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
  
  // 檢查是否為 Android 平板
  const isAndroidTablet = /Android/.test(navigator.userAgent) && !/Mobile/.test(navigator.userAgent);
  
  // 一般觸控設備檢測
  const hasTouch = 'ontouchstart' in window ||
                  navigator.maxTouchPoints > 0 ||
                  navigator.msMaxTouchPoints > 0;
  
  // 如果是 iOS 設備、Android 平板或其他觸控設備，則返回 true
  return isIOS || isAndroidTablet || hasTouch;
};

// 打開觸控環境
const isMouseOnlyDevice = true;
if (isMouseOnlyDevice) {
  import("../api/jsmindlib/jsmind.draggable-node.js");
}

export default {
  components: { MindMapImgEditor, SvgIcon, QDialog, MindMapTreeMenuVue, SelectMenu, BaseModal, QRCodeDialog },
  name: "MindMap",

  setup() {
    let that = getCurrentInstance().proxy;
    const route = useRoute();
    const router = useRouter();
    const iviewMessage = inject("$Message");
    const showImgEditor = ref(false);
    const showStaticUrlDialog = ref(false);
    const staticMindmapUrl = ref('');
    const inputImgFileBeforeOpenCanvas = ref("");
    const currentImgUrl = ref("");
    const currentMoveTargetNode = ref("");
    const isDeleting = ref(false);
    const showAvatarMenu = ref(false);
    const showMainMenu = ref(false);
    const $q = useQuasar();
    const { directDispose,
      isInitReadingFluidData,
      currentCoworkMemberList,
      coworkLeader,
      setFluidMindHistory,
      setFluidMindNodeData,
      setFluidCoworkMode,
      clearFluidMindNodeData,
      testFluidShareMapInMind } = useMindMapFluidSync({
        route,
        iviewMessage,
      });

    const { mindMapStore, initMindMapBlob, mindMapUploadFile } = useMindMapBlob();
    const { createMindCollectFromTemplate } = useAssignmentTaskCreator();

    // 推送按鈕冷卻狀態
    const isSendDisabled = ref(false);
    const cooldownTimer = ref(null);

    // HT 軟體版本號（用於版本相容性處理）
    const hostSoftwareVersion = ref('');

    const handleAvatarClickOutside = (event) => {
      if (!event.target.closest(".nav-menu") && !event.target.closest(".avatar")) {
        showAvatarMenu.value = false;
      }
    };
    const handleMainMenuClickOutside = (event) => {
      if (!event.target.closest(".main-menu") && !event.target.closest(".hamburger-icon")) {
        showMainMenu.value = false;
      }
    };
    const logout = () => {
      try {
        directDispose();
      } catch (error) {
        console.warn("already destroy");
      }

      showAvatarMenu.value = false;
      if (that.isLogin) {
        api.main.logout().then(async () => {
          iviewMessage.info(that.$t("mindmap.mindmapHome.logoutOK"));
          that.isLogin = false;
          localStorage.clear();
          sessionStorage.clear();
          router.push("/MindMapHome");
        });
      }
    };

    const sendMDtoHTWb = () => {
      let jmNode = that.jm.get_data("node_tree");

      //檢查根節點欄位缺失
      if (jmNode.data.id == "root") {
        if (!jmNode.data.hasOwnProperty("index") || jmNode.data?.index == undefined) jmNode.data.index = 0;
        if (!jmNode.data.hasOwnProperty("nodeImg")) jmNode.data.nodeImg = "";
        if (!jmNode.data.hasOwnProperty("nodeLink")) jmNode.data.nodeLink = "";
        if (!jmNode.data.hasOwnProperty("nodeText")) jmNode.data.nodeText = "root";
        if (!jmNode.data.hasOwnProperty("note")) jmNode.data.note = "";
      }

      let mdText = md.jsMindToMd(jmNode, that);

      console.log({
        item: mdText,
        action: "MD.Push",
        fromSharing: true,
        mindId: that.route.query.id,
      });
      if (window?.chrome?.webview)
        window?.chrome?.webview.postMessage({
          fromSharing: true,
          mindId: that.route.query.id,
          item: mdText,
          action: "MD.Push",
          title: "",
        });
    };

    const sendSizeToHTWb = () => {
      setTimeout(() => {
        console.log({
          size: {
            width: window.innerWidth,
            height: window.innerHeight,
          },
          fromSharing: true,
          mindId: that.route.query.id,
          action: "sizeWb",
        });
        window?.chrome?.webview.postMessage({
          size: {
            width: window.innerWidth,
            height: window.innerHeight,
          },
          mindId: that.route.query.id,
          fromSharing: true,
          action: "sizeWb",
          title: "",
        });
      }, 0);
    };

    const isWebView = computed(() => {
       return window?.chrome?.webview || false;
    });

    // ========== 新增：判斷是否應該顯示推送按鈕（WebView 或 iframe） ==========
    const shouldShowPushButton = computed(() => {
      const isInIframe = window.self !== window.top;
      return isWebView.value || isInIframe;
    });
    // ========== 新增結束 ==========

    const handleSendClick = () => {
      console.log('按鈕點擊，當前禁用狀態：', isSendDisabled.value);

      if (isSendDisabled.value) {
        iviewMessage.warning({
          content: that.$t('mindmap.linkShareCooldown'),
          duration: 3,
          closable: true
        });
        return;
      }

      // 執行推送
      sendToWebIRS();
      iviewMessage.success({
        content: that.$t('mindmap.linkShareSuccess'),
        duration: 3,
        closable: true
      });

      // 設置冷卻狀態
      isSendDisabled.value = true;
      console.log('設置為禁用狀態：', isSendDisabled.value);

      // 清除舊的 timer（如果存在）
      if (cooldownTimer.value) {
        clearTimeout(cooldownTimer.value);
      }

      // 1分鐘後恢復
      cooldownTimer.value = setTimeout(() => {
        isSendDisabled.value = false;
        console.log('恢復為啟用狀態：', isSendDisabled.value);
        cooldownTimer.value = null; // 清除 timer 引用
      }, 60000); // 60秒
    };

    const sendToWebIRS = () => {
      if (window?.chrome?.webview) {
        window?.chrome?.webview.postMessage({
          action: 'SendMindMapLink.WebIRS',
          data:{
            url: that.shortURLHost + that.currentMindMapURL,
          }
        });
        console.log('SendMindMapLink.WebIRS', {
          action: 'SendMindMapLink.WebIRS',
          data:{
            url: that.shortURLHost + that.currentMindMapURL,
          }
        });
      }

      // ========== 新增：iframe 模式支援 ==========
      const isInIframe = window.self !== window.top;
      if (isInIframe) {
        const message = {
          action: 'SendMindMapLink.WebIRS',
          data:{
            url: that.shortURLHost + that.currentMindMapURL,
          }
        };
        window.parent.postMessage(message, '*');
        console.log('[MindMap] [iframe] 發送 SendMindMapLink.WebIRS:', message);
      }
      // ========== 新增結束 ==========
    }

    // 將圖片 URL 轉換為 Base64 (用於 topic 中的 <img> 標籤)
    const convertImageToBase64 = async (url) => {
      // 檢查是否已經是 base64
      if (url.startsWith('data:image/')) {
        return url;
      }

      try {
        const response = await fetch(url);
        const blob = await response.blob();

        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            // 轉換為 JPEG base64，品質 0.9
            const jpegBase64 = canvas.toDataURL('image/jpeg', 0.9);
            resolve(jpegBase64);
          };
          img.onerror = () => {
            console.error("圖片載入失敗");
            resolve(url); // 失敗時返回原始 URL
          };

          const objectUrl = URL.createObjectURL(blob);
          img.src = objectUrl;
        });
      } catch (error) {
        console.error("圖片轉換失敗", error);
        return url; // 失敗時返回原始 URL
      }
    };

    // 處理心智圖資料（用於本地儲存）
    const processMindMapData = async (data) => {
      if (!data || !data.data) return;

      const processNode = async (node) => {
        // 檢查 topic 中是否包含圖片，並轉換為 base64
        const imgMatch = node.topic.match(/<img[^>]+src=["']([^"']+)["'][^>]*>/);
        if (imgMatch && !imgMatch[1].startsWith("data:image")) {
          const base64Image = await convertImageToBase64(imgMatch[1]);
          node.topic = node.topic.replace(
            /<img[^>]+src=["']([^"']+)["'][^>]*>/,
            `<img class='mindmap-img' src='${base64Image}'/>`
          );
        }

        // 遞迴處理子節點
        if (node.children && Array.isArray(node.children)) {
          await Promise.all(node.children.map(processNode));
        }
      };

      await processNode(data.data);
      return data;
    };

    const convertImgToBase64 = async (json) => {
      const traverseNodes = async (node) => {
        // 替换 nodeImg
        if (node.nodeImg) {
          try {
            const base64 = await getBase64FromBlobUrl(node.nodeImg);
            node.nodeImg = base64; // 替换为 Base64
          } catch (error) {
            console.error(`Failed to convert nodeImg: ${node.nodeImg}`, error);
          }
        }

        // 替换 <img> 的 src
        if (node.topic) {
          const matches = [...node.topic.matchAll(/<img[^>]+src="([^">]+)"/g)];
          for (const match of matches) {
            const blobUrl = match[1]; // 图片 URL
            try {
              const base64 = await getBase64FromBlobUrl(blobUrl);
              node.topic = node.topic.replace(blobUrl, base64); // 替换为 Base64
            } catch (error) {
              console.error(`Failed to convert img src: ${blobUrl}`, error);
            }
          }
        }

        // 如果有子节点，递归处理
        if (node.children && Array.isArray(node.children)) {
          for (const child of node.children) {
            await traverseNodes(child);
          }
        }
      };

      // 从根节点开始遍历
      await traverseNodes(json.data);
      return json;
    };

    // 处理数据并发送回 WebView
    // 根據版本移除 nodeImg 和 nodeLink（不管 isForLocalSave）
    const removeNodeImgByVersion = (data) => {
      if (!data || !data.data) return data;

      const processNode = (node) => {
        // 配合 HT 版本判斷，移除欄位
        if (hostSoftwareVersion.value) {
          const versionParts = hostSoftwareVersion.value.split('.'); // 按點拆分版號
          const majorMinor = parseFloat(`${versionParts[0]}.${versionParts[1]}`); // 提取主版本和次版本
          const patchVersion = parseInt(versionParts[3], 10); // 提取補丁版本（最後一部分）

          // 5.3.0.0022 版本以上，移除 nodeImg 與 nodeLink 功能
          if (majorMinor > 5.3 || (majorMinor === 5.3 && patchVersion > 22) || parseFloat(versionParts[0]) >= 6) {
            console.log("hostSoftwareVersion:" + hostSoftwareVersion.value, "remove nodeImg, nodeLink");
            delete node.nodeImg;
            delete node.nodeLink;
          }
        }

        // 遞迴處理子節點
        if (node.children && Array.isArray(node.children)) {
          node.children.forEach(processNode);
        }
      };

      processNode(data.data);
      return data;
    };

    const sendBackToHTWb = async (action, isForLocalSave = false) => {
      if (!that?.jm?.get_data("node_tree")) {
        return;
      }

      // 获取 node_tree 数据
      let beforeData = that.jm.get_data("node_tree");

      //檢查根節點欄位缺失
      if (beforeData.data.id == "root") {
        if (!beforeData.data.hasOwnProperty("index") || beforeData.data?.index == undefined) beforeData.data.index = 0;
        if (!beforeData.data.hasOwnProperty("nodeImg")) beforeData.data.nodeImg = "";
        if (!beforeData.data.hasOwnProperty("nodeLink")) beforeData.data.nodeLink = "";
        if (!beforeData.data.hasOwnProperty("nodeText")) beforeData.data.nodeText = "root";
        if (!beforeData.data.hasOwnProperty("note")) beforeData.data.note = "";
      }

      console.log("Original Data:", beforeData.data);

      // 先複製資料以避免修改原始資料
      let backData = JSON.parse(JSON.stringify(beforeData));

      // 不管 isForLocalSave 是什麼，都要根據版本移除 nodeImg 和 nodeLink
      backData = removeNodeImgByVersion(backData);

      // 根據 isForLocalSave 決定是否要處理圖片轉 base64
      if (isForLocalSave) {
        // 本地儲存：使用 processMindMapData 處理 topic 中的 <img>
        // 並使用 convertImgToBase64 處理 nodeImg 欄位
        backData = await processMindMapData(backData);
        backData = await convertImgToBase64(backData);
        console.log("isForLocalSave - 已使用 processMindMapData 和 convertImgToBase64 處理");
      }

      // 序列化并发送数据
      const jsonData = JSON.stringify(backData);
      console.log({ item: jsonData, action, isForLocalSave });

      if (window?.chrome?.webview) {
        window?.chrome?.webview.postMessage({
          fromSharing: true,
          mindId: that.route.query.id,
          item: jsonData,
          action: action,
          title: "",
        });
      }
    };

    // 从 Blob URL 获取 Base64 编码
    const getBase64FromBlobUrl = async (blobUrl) => {
      return new Promise((resolve, reject) => {
        const imageObj = new Image();
        imageObj.crossOrigin = "Anonymous"; // 确保跨域加载
        imageObj.src = blobUrl;

        imageObj.onload = () => {
          const originalWidth = imageObj.width;
          const originalHeight = imageObj.height;

          const { ratio } = calScaleRatio(originalWidth, originalHeight, 1024, 1024);

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          canvas.width = originalWidth * ratio;
          canvas.height = originalHeight * ratio;

          context.drawImage(imageObj, 0, 0, canvas.width, canvas.height);

          try {
            const base64URL = canvas.toDataURL("image/png");
            resolve(base64URL);
          } catch (error) {
            reject(`Failed to convert to Base64: ${error.message}`);
          }
        };

        imageObj.onerror = (error) => {
          reject(`Failed to load image: ${error.message}`);
        };
      });
    };

    // 用于计算图片缩放比例
    function calScaleRatio(width, height, maxWidth, maxHeight) {
      const ratio = Math.min(maxWidth / width, maxHeight / height, 1);
      return { ratio };
    }

    const sendBase64toHTWb = () => {
      $q.loading.show();
      let jmDom = document.getElementById("jsmind_container");
      let jmnodesElement = document.querySelector("jmnodes");
      //先將Dom放大到跟繪圖區等大，再截圖

      jmDom.style.height = jmnodesElement.offsetHeight + "px";
      jmDom.style.width = jmnodesElement.offsetWidth + "px";
      that.jm.resize();

      setTimeout(() => {
        htmlToImage.toPng(jmDom).then(async (dataURL) => {
          if (window?.chrome?.webview)
            window?.chrome?.webview.postMessage({
              fromSharing: true,
              mindId: that.route.query.id,
              base64Image: dataURL, //傳送整份base64
              action: "Snapshot.Push",
              title: "",
            });
          jmDom.style.height = "100vh";
          jmDom.style.width = "100%";
          that.jm.resize();
          that.$q.loading.hide();
        });
      }, 200);
    };

    // 發送截圖給父窗口（HiTeachCC）
    const sendSnapshotToParent = () => {
      $q.loading.show();
      let jmDom = document.getElementById("jsmind_container");
      let jmnodesElement = document.querySelector("jmnodes");

      if (!jmDom || !jmnodesElement) {
        console.error('[MindMap] 無法找到心智圖 DOM 元素');
        $q.loading.hide();
        return;
      }

      // 先將 Dom 放大到跟繪圖區等大，再截圖
      const originalHeight = jmDom.style.height;
      const originalWidth = jmDom.style.width;

      jmDom.style.height = jmnodesElement.offsetHeight + "px";
      jmDom.style.width = jmnodesElement.offsetWidth + "px";
      that.jm.resize();

      setTimeout(() => {
        htmlToImage.toPng(jmDom).then((dataURL) => {
          console.log('[MindMap] 截圖完成，發送給父窗口');

          // 發送截圖給父窗口
          const message = {
            action: 'MindMap.SnapshotResponse',
            base64Image: dataURL
          };

          window.parent.postMessage(message, '*');

          // 恢復原始尺寸
          jmDom.style.height = originalHeight || "100vh";
          jmDom.style.width = originalWidth || "100%";
          that.jm.resize();
          $q.loading.hide();

          console.log('[MindMap] 截圖已發送給父窗口');
        }).catch((error) => {
          console.error('[MindMap] 截圖失敗:', error);
          // 恢復原始尺寸
          jmDom.style.height = originalHeight || "100vh";
          jmDom.style.width = originalWidth || "100%";
          that.jm.resize();
          $q.loading.hide();
        });
      }, 200);
    };

    provide("showImgEditor", showImgEditor); //向子組件提供參數
    provide("inputImgFileBeforeOpenCanvas", inputImgFileBeforeOpenCanvas);
    provide("mindMapUploadFile", mindMapUploadFile);
    provide("currentImgUrl", currentImgUrl);
    provide("currentMoveTargetNode", currentMoveTargetNode);

    onMounted(async () => {
      // 處理 URL 參數中的語系切換
        const languageParam = route.query.l;
        if (languageParam) {
            that.handleLanguageSwitch(String(languageParam));
            // 移除 URL 中的 l 參數
            const url = new URL(window.location.href);
            url.searchParams.delete('l');
            window.history.replaceState({}, document.title, url.toString());
        }

      if (window?.chrome?.webview) {
        $q.loading.show();
        sendSizeToHTWb();

        window?.chrome?.webview.addEventListener("message", async function (e) {
          let msg = JSON.parse(e.data);
          console.log(msg, "收到HT webView訊息  在心智圖頁面");

          if (msg.action == "initialMindMap") {
            //接收更新的token
            if (msg.parameters.access_Token) {
              localStorage.setItem("access_token", msg.parameters.access_Token);
              localStorage.setItem("expires_in", msg.parameters.expires_in);
            }
            // 接收 HT 軟體版本號
            if (msg.parameters?.hostSoftwareVersion) {
              hostSoftwareVersion.value = msg.parameters.hostSoftwareVersion;
              console.log("接收到 HT 軟體版本:", hostSoftwareVersion.value);
            }
          }
          if (msg.action == "initialMindMapByMD") {
            // 接收 HT 軟體版本號
            if (msg.parameters?.hostSoftwareVersion) {
              hostSoftwareVersion.value = msg.parameters.hostSoftwareVersion;
              console.log("接收到 HT 軟體版本:", hostSoftwareVersion.value);
            }
            iviewMessage.info(that.$t("mindmap.unsupportFC"));
          } else if (msg.action == "MD.Get") {
            sendMDtoHTWb();
          } else if (msg.action == "GetAllBackup") {
            let isForLocalSave = msg.hasOwnProperty("isForLocalSave") ? msg.isForLocalSave : false;
            await sendBackToHTWb("LayerBackup", isForLocalSave);
          } else if (msg.action == "ScreenLarge") {
            // if (that.currentCoworkType != 'All') {
            //   that.showAllTool = true
            // }
            $q.loading.show();
            setTimeout(() => {
              that.jm.resize();
              $q.loading.hide();
            }, 100);
          } else if (msg.action == "ScreenNormal") {
            // if (that.currentCoworkType != 'All') {
            //   that.showAllTool = false
            // }
            $q.loading.show();
            setTimeout(() => {
              that.jm.resize();
              $q.loading.hide();
            }, 100);
          } else if (msg.action == "Snapshot.Get") {
            sendBase64toHTWb();
          }
        });
      }
      document.addEventListener("click", handleAvatarClickOutside);
      document.addEventListener("click", handleMainMenuClickOutside);

      // ========== 雲心智圖：在組件掛載時立即發送當前 URL ==========
      const isInIframe = window.self !== window.top;
      if (isInIframe) {
        // 延遲一下確保組件完全掛載
        setTimeout(() => {
          const currentUrl = route.fullPath;
          const message = {
            action: 'MindMap.UrlChanged',
            url: currentUrl,
            fullUrl: window.location.href
          };
          console.log('[MindMap] 組件掛載，發送當前 URL:', currentUrl);
          console.log('[MindMap] 發送協議:', message);
          window.parent.postMessage(message, '*');
        }, 200);

        // 監聽來自父窗口（HiTeachCC）的訊息
        window.addEventListener('message', (event) => {
          console.log('[MindMap] 收到父窗口訊息:', event.data);

          // 處理截圖請求
          if (event.data.action === 'HiTeachCC.RequestSnapshot') {
            console.log('[MindMap] 收到截圖請求，開始截圖');
            sendSnapshotToParent();
          }
          // 處理認證協議
          else if (event.data.action === 'HiTeachCC.Auth') {
            console.log('[MindMap] 收到認證協議:', event.data);
            // 更新 token
            if (event.data.accessToken) {
              localStorage.setItem('access_token', event.data.accessToken);
              localStorage.setItem('idToken', event.data.idToken);
              localStorage.setItem('expires_in', event.data.expiresIn);
              console.log('[MindMap] Token 已更新');
            }
          }
        });
      }
      // ========== 雲心智圖：立即發送結束 ==========
    });
    onBeforeUnmount(() => {
      document.removeEventListener("click", handleAvatarClickOutside);
      document.removeEventListener("click", handleMainMenuClickOutside);

      if (cooldownTimer.value) {
        clearTimeout(cooldownTimer.value);
        cooldownTimer.value = null;
      }
    });
    iviewMessage.loading({
      content: "",
      duration: 0.001,
    });

    // ========== 雲心智圖：監聽路由變化並回報給父視窗（用於翻頁記憶） ==========
    /**
     * 發送 URL 變化通知給父視窗
     */
    const notifyUrlChange = (url) => {
      const isInIframe = window.self !== window.top;
      if (!isInIframe) return;

      const message = {
        action: 'MindMap.UrlChanged',
        url: url,
        fullUrl: window.location.href
      };

      console.log('[MindMap] 發送 URL 變化通知:', url);
      console.log('[MindMap] 發送協議:', message);
      window.parent.postMessage(message, '*');
    };

    /**
     * 監聽路由變化
     */
    watch(() => route.fullPath, (newPath, oldPath) => {
      if (newPath !== oldPath) {
        console.log('[MindMap] 路由變化:', oldPath, '→', newPath);
        notifyUrlChange(newPath);
      }
    }, { immediate: false });
    // ========== 雲心智圖：路由監聽結束 ==========

    return {
      isWebView,
      shouldShowPushButton,
      isDeleting,
      logout,
      currentCoworkMemberList,
      coworkLeader,
      currentMoveTargetNode,
      iviewMessage,
      route,
      currentImgUrl,
      showImgEditor,
      showStaticUrlDialog,
      staticMindmapUrl,
      showMainMenu,
      showAvatarMenu,
      mindMapStore,
      initMindMapBlob,
      inputImgFileBeforeOpenCanvas,
      mindMapUploadFile,
      //shareMap存歷史的方式
      testFluidShareMapInMind,
      setFluidMindHistory,
      setFluidMindNodeData,
      router,
      isInitReadingFluidData,
      clearFluidMindNodeData,
      sendMDtoHTWb,
      sendBackToHTWb,
      setFluidCoworkMode,
      createMindCollectFromTemplate,
      isSendDisabled,
      handleSendClick,
      showQRCodeCard: ref(false),
      qrCodeUrl: ref(''),
      qrCodeShortCode: ref(''),
    };
  },
  data() {
    return {
      isPhonetic: false,
      isZHTW: false,
      fontLoaded: false,
      fontLoading: false,
      isDraggingEnabled: false, // 新增：控制節點拖曳功能的開關
      hasShownTooManyUsersWarning: false, // 追蹤是否已顯示過人數過多警告
      isUserLimitReached: false, // 追蹤是否達到人數上限
      showSaveStatus: true,
      profile: {
        name: "",
        teammodelId: "",
        picture: "",
      },
      isLogin: false,
      currentViewImg: "",
      showBigImg: false,
      jmNodeAttechIcon: jmNodeIconStr.attachment,
      jm: null,
      ctrlNodeMode: "add",
      currentNode: null,
      showAddNoteTool: false,
      nodeText: "",
      nodeTextNote: "", //更詳細的說明文字
      nodeTextURL: "",
      direction: "left",
      isCurrentSelectRoot: false,
      isCurrentNodeCanBeDelete: false,
      isCurrentNodeCanMoveUp: false,
      isCurrentNodeCanMoveDown: false,
      isCurrentNodeHasChildren: false,
      showNodeMenu: false,
      currentNodeHasImg: false,
      posX: 0,
      posY: 0,
      mind: {
        meta: { name: "jsMind-demo-tree", author: "", version: "" },
        format: "node_tree",
        data: {
          id: "root",
          topic: "<p>root</p>",
          index: 0,
          nodeText: "root",
          nodeImg: "",
          nodeLink: "",
          expanded: true,
          lock: false,
          isroot: true,
        },
      },
      options: {
        log_level: "error",
        container: "jsmind_container",
        editable: true,
        theme: "webirs",
        support_html: true,
        view: {
          engine: "svg",
          line_width: 4, // 線條粗細
          line_color: "#84c9c2", // 線條顏色
        },
      },
      maxImageSize: 3,
      isOverMaxImageSize: false,
      isUploadImg: false,
      showSelectedNote: false,
      nodeEditBy: { seat: "", name: "" },
      showMoreSetting: false,
      currentLineColor: "#0000ff",
      currentNodeColor: "rgb(255, 238, 139)",
      lineColorArr: ["red", "orange", "yellow", "cyan", "#e0e0e0", "brown", "purple", "green", "#0000ff", "black"],
      nodeColorArr: ["rgb(255, 238, 139)", "rgb(211, 255, 139)", "rgb(139, 243, 255)", "rgb(255, 191, 215)"],
      anonymousSeat: "",
      selfEditMode: false,
      isModified: false,
      autoSaveIntervalId: null,
      isCurrentNodePreEditByMe: false,
      nameLabelX: 0,
      nameLabelY: 0,
      currentNameLabel: "",
      showNameLabel: false,
      isNoSnapShot: false,
      currentMindMapInfo: "",
      coworkMode: "view",
      isCreator: false,
      showForbidden: false,
      showForbiddenCollect: false,
      showNotAllowView: false,
      showMoveTool: false,
      treeMenuData: "",
      verticalLines: [],
      horizontalLines: [],
      drawLineTimeoutId: null,
      drawLineAreaH: 0,
      showMemberList: false,
      currentMindmapName: "",
      showRenameBox: false,
      renameVal: "",
      titleEditVal: "",
      isCurrentNodeLock: false,
      isLoadingMD: false,
      anonymousTempName: "",
      currentAnonymousTempName: "",
      showAnonymousNameBox: false,
      tokenRefreshInterval: null,
      showShareLinkBox: false,
      currentMindMapURL: "",
      currentMindmapStaticCode: "", // 靜態心智圖短網址減碼
      currentMindmapStaticUpdateTime: null, // 靜態心智圖更新時間
      coworkModeCate: [this.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer"), this.$t("mindmap.mindmapHome.coworkModeNoteText.editLongVer")],
      inactivityTimer: null,
      warningTimer: null,
      showRefreshHint: false,
      mindCollecInfo: "",
      isInCollect: false,
      collectIdType: "",
      showEditKeyForm: false,
      userInputKey: "",
      isCurrentNodeCanMoveLeft: false,
      isCurrentNodeCanMoveRight: false,
      enterMindHistory: {},
      shortURLHost: "https://api2-rc.teammodel.net/",
      historyUpdateInterval: null,
      showPasteMDForm: false,
      pasteMDText: "",
    };
  },
  async mounted() {
    // 語言檢測
    this.isZHTW = this.$i18n.locale.toLowerCase() == 'zh-tw';
    console.log('語言設定:', this.$i18n.locale, 'isZHTW:', this.isZHTW);

    let serverLocation = api.main.getServerLocation();
    let dataCenter = (serverLocation.includes("cn")) ? "cn" : "global";
    this.shortURLHost = confProfile.shortUrlHost[dataCenter];


    sessionStorage.setItem("anonymousSeat", this.anonymousSeat);
    sessionStorage.setItem("currentAnonymousTempName", this.currentAnonymousTempName);

    // 每 5 分鐘更新一次最近點閱到後端
    this.historyUpdateInterval = setInterval(() => this.saveEnterMindHistoryDB(), 5 * 60 * 1000);


    this.anonymousSeat = sessionStorage.getItem("anonymousSeat") || "anonymous-" + this.genUUID();

    sessionStorage.setItem("anonymousSeat", this.anonymousSeat);
    try {
      await this.initializeAuth();
      await this.getMindMapSas();
      this.startTokenRefreshInterval();
      await this.getCurrentMindMapInfo(); //一開始就先拉資料
      console.log(this.currentMindMapInfo, "this.currentMindMapInfo");

      this.renameVal = this.currentMindMapInfo.mindmapName;
    } catch (error) {
      console.error("Error fetching auth token or mind map SAS:", error);
    }

    if (!this.route.query?.id) {
      this.iviewMessage.warning({
        content: this.$t("mindmap.initializeFailed"),
        duration: 100,
        closable: true
      });
      return;
    }

    await this.handleLoginAndProfile();

    // 在 handleLoginAndProfile 之後再檢查登入狀態
    this.checkLoginStatus();

    if (this.isLogin) {
      // 載入歷史記錄
      const storageKey = `enterMindHistory_${this.profile.teammodelId}`;
      const histories = JSON.parse(localStorage.getItem(storageKey) || '[]');
      Object.assign(this.enterMindHistory, histories);
      this.saveEnterMindHistory(this.currentMindMapInfo);
    }

    this.setupMindMapEventListeners();
    this.setupMouseEvents();
    this.startAutoSave();


    if (this.route.query?.showShareLinkBox) {
      this.openShareLinkBox();
    }

    if (!window?.chrome?.webview && !this.isLogin) {
      //匿名會偵測10分鐘無操作斷開
      // console.log("不是webview", this.isLogin);
      this.resetTimer();
      this.bindInactivityEvents();
    }
     
  },
  beforeUnmount() {
    clearInterval(this.autoSaveIntervalId);
    clearInterval(this.tokenRefreshInterval);
    clearInterval(this.historyUpdateInterval);
    this.autoSaveIntervalId = null;
    this.tokenRefreshInterval = null;
    this.historyUpdateInterval = null;
    this.removeInactivityTimeout();
  },
  computed: {
    showSaveCoworkBtn() {
      const coworkModeTextOrigin = this.$refs.coworkModeSelect.currentSelect === this.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit";
      return this.currentMindMapInfo.coworkMode && coworkModeTextOrigin != this.currentMindMapInfo.coworkMode;
    },
    fromInfo() {
      let seat = "";
      let name = "";
      if (localStorage.getItem("profile")) {
        let localeProfile = JSON.parse(localStorage.getItem("profile"));
        seat = localeProfile?.id || localeProfile?.teammodelId;
        name = localeProfile.name;
      } else {
        seat = this.anonymousSeat;
        name = this.currentAnonymousTempName;
      }
      return {
        seat: seat,
        name: name,
        // seat: this.$mobileirs.HiGroup ? 'G' + this.$mobileirs.HiGroupID : this.$mobileirs.seat,
        // name: this.$mobileirs.HiGroup ? this.$mobileirs.HiGroupName : this.$mobileirs.name
      };
    },
    // mindMapInfo() {
    //   return this.$mobileirs.msgMindMapInfo
    // },

    nodeTextLength() {
      return this.nodeText.length;
    },
    nodeTextNoteLength() {
      return this.nodeTextNote.length;
    },
    // 顯示標題：如果正在編輯標題則顯示編輯中的值，否則顯示原始值
    displayMindmapName() {
      if (this.showShareLinkBox && this.titleEditVal && this.titleEditVal.trim() !== '') {
        return this.titleEditVal;
      }
      if (this.showRenameBox && this.renameVal && this.renameVal.trim() !== '') {
        return this.renameVal;  
      }
      return this.currentMindmapName;
    },
  },
  watch: {
    async isPhonetic(newValue) {
      // console.log('isPhonetic watch 觸發, 新值:', newValue);

      // 如果開啟注音且字體尚未載入，則載入字體
      if (newValue && !this.fontLoaded) {
        // console.log('需要載入字體, fontLoaded:', this.fontLoaded);
        const success = await this.loadPhoneticFont();
        if (!success) {
          // 字體載入失敗，關閉注音模式
          this.isPhonetic = false;
          this.$message.error('注音字體載入失敗');
          return;
        }
      }

      this.relayout();
    },
    isDraggingEnabled(value) {
      // 當拖曳功能開關變化時，更新 jsMind 拖曳控制器的狀態
      if (this.jm && this.jm.draggable_controller) {
        this.jm.draggable_controller.set_drag_enabled(value);
        // console.log('拖曳功能狀態已更新：', value ? '啟用' : '禁用');
      }
    },
    showNameLabel(value) {
      if (value == false) {
        this.hideNameLabel();
      }
    },
    currentCoworkMemberList(value) {
      if (value && value.length > 100) {
        this.isUserLimitReached = true;
        if (!this.hasShownTooManyUsersWarning) {
          this.hasShownTooManyUsersWarning = true;
          this.iviewMessage.warning({
            content: this.$t("mindmap.tooManyUsers"),
            duration: 5000,
            closable: true
          });
        }
      } else {
        // 當沒有協作用戶時重置狀態
        this.isUserLimitReached = false;
        this.hasShownTooManyUsersWarning = false;
      }
    }
  },
  methods: {
    async loadPhoneticFont() {
      if (this.fontLoaded) return true;

      try {
        this.fontLoading = true;

        // 顯示全屏 Loading
        this.$q.loading.show({
          message: '載入注音字體中...',
          spinnerColor: 'primary'
        });

        console.log('開始載入注音字體...');

        // 使用 Font Loading API 動態載入字體
        const fontUrl = require('../assets/fonts/BpmfZihiKaiStd-Regular.ttf');
        const font = new FontFace(
          'BpmfZihiKaiStd',
          `url(${fontUrl})`
        );

        await font.load();
        document.fonts.add(font);

        this.fontLoaded = true;
        console.log('注音字體載入成功！');
        return true;
      } catch (error) {
        console.error('注音字體載入失敗:', error);
        return false;
      } finally {
        this.fontLoading = false;
        // 隱藏 Loading
        this.$q.loading.hide();
      }
    },
    async saveEnterMindHistoryDB() {
      if (!this.isLogin || !this.profile.teammodelId) return; // 確保已登入且有用戶 ID

      const payload = {
        fromUser: {
          id: this.profile.teammodelId,
          name: this.profile.name,
        },
        mindmapHistories: Object.values(this.enterMindHistory).slice(0, 12), // 限制最多 12 筆
      };

      try {
        await api.mindmapAPI.saveMindClickHistory(payload);
      } catch (error) {
        console.error("Failed to update mind click history:", error);
      }
    },
    checkSessionEditKey() { //只要同一個session重刷就可以一直編輯
      if (sessionStorage.getItem("mindSubCreatorEditKey") && this.currentMindMapInfo) {
        return this.currentMindMapInfo.mindSubCreatorEditKey === sessionStorage.getItem("mindSubCreatorEditKey");
      } else {
        return false;
      }
    },
    
    // 檢查本地存儲的編輯密鑰
    checkLocalEditKey() {
      // 清理過期的編輯密鑰
      this.cleanExpiredEditKeys();
      
      // 檢查本地存儲是否有對應的編輯密鑰
      if (this.currentMindMapInfo) {
        const storedKeyList = JSON.parse(localStorage.getItem("mindSubCreatorEditKeyList") || "[]");
        const foundKey = storedKeyList.find(item => item.id === this.currentMindMapInfo.id);
        
        if (foundKey) {
          return foundKey.key === jsFn.decrypt(this.currentMindMapInfo.mindSubCreatorEditKey);
        }
      }
      return false;
    },
    
    // 保存編輯密鑰到本地存儲
    saveEditKeyToLocal() {
      if (!this.currentMindMapInfo || !this.currentMindMapInfo.mindSubCreatorEditKey) return;
      
      // 獲取現有的列表或創建新列表
      const storedKeyList = JSON.parse(localStorage.getItem("mindSubCreatorEditKeyList") || "[]");
      
      // 檢查是否已存在相同 ID 的記錄
      const existingIndex = storedKeyList.findIndex(item => item.id === this.currentMindMapInfo.id);
      
      // 創建新記錄
      const newKeyItem = {
        id: this.currentMindMapInfo.id,
        key: jsFn.decrypt(this.currentMindMapInfo.mindSubCreatorEditKey),
        timestamp: new Date().getTime()
      };
      
      // 更新或添加記錄
      if (existingIndex !== -1) {
        storedKeyList[existingIndex] = newKeyItem;
      } else {
        storedKeyList.push(newKeyItem);
      }
      
      // 保存到本地存儲
      localStorage.setItem("mindSubCreatorEditKeyList", JSON.stringify(storedKeyList));
    },
    
    // 清理過期的編輯密鑰（超過一天）
    cleanExpiredEditKeys() {
      const storedKeyList = JSON.parse(localStorage.getItem("mindSubCreatorEditKeyList") || "[]");
      const currentTime = new Date().getTime();
      const oneDayInMs = 24 * 60 * 60 * 1000; // 一天的毫秒數
      
      // 過濾掉過期的密鑰
      const validKeyList = storedKeyList.filter(item => {
        return (currentTime - item.timestamp) < oneDayInMs;
      });
      
      // 如果有過期的密鑰被移除，更新本地存儲
      if (validKeyList.length !== storedKeyList.length) {
        localStorage.setItem("mindSubCreatorEditKeyList", JSON.stringify(validKeyList));
      }
    },
    confirmToCheckKey() {
      if (jsFn.decrypt(this.currentMindMapInfo.mindSubCreatorEditKey) == this.userInputKey) {

        sessionStorage.setItem("mindSubCreatorEditKey", this.currentMindMapInfo.mindSubCreatorEditKey);

        this.iviewMessage.info(this.$t("mindmap.allowEnterEditSuccess"));
        this.coworkMode = "edit";
        this.showEditKeyForm = false;

        if (this.showNotAllowView) { //不允許觀看-輸入密碼後才初始化
          this.showNotAllowView = false;
          this.initMindMap();
        }

      } else {
        this.iviewMessage.error(this.$t("mindmap.enterEditKeyWrong"));
      }

      // console.log(jsFn.decrypt(this.currentMindMapInfo.mindSubCreatorEditKey), "this.mindCollecInfo");
    },
    resetUserInputKey() {
      this.userInputKey = "";
    },
    checkBeforeEdit() {
      this.showEditKeyForm = true;
    },
    openQRCode(url, shortCode) {
      this.qrCodeUrl = url;
      this.qrCodeShortCode = shortCode;
      this.showQRCodeCard = true;
    },
    closeQRCode() {
      this.showQRCodeCard = false;
    },
    copyShortUrl() {
      const url = this.shortURLHost + this.currentMindMapURL;
      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('Copy');
      document.body.removeChild(input);
      this.iviewMessage.info(this.$t("mindmap.mainMenu.alreadyCopied"));
    },
    bindInactivityEvents() {
      document.addEventListener("mousemove", () => {
        this.resetTimer();
      });
      document.addEventListener("click", () => {
        this.resetTimer();
      });
      document.addEventListener("keydown", () => {
        this.resetTimer();
      });
      document.addEventListener("touchstart", () => {
        this.resetTimer();
      });
    },
    unbindInactivityEvents() {
      document.removeEventListener("mousemove", () => {
        this.resetTimer();
      });
      document.removeEventListener("click", () => {
        this.resetTimer();
      });
      document.removeEventListener("keydown", () => {
        this.resetTimer();
      });
      document.removeEventListener("touchstart", () => {
        this.resetTimer();
      });
    },
    removeInactivityTimeout() {
      clearTimeout(this.inactivityTimer);
      clearTimeout(this.warningTimer);
      this.inactivityTimer = null;
      this.warningTimer = null;
    },
    resetTimer() {
      // console.log("重新計時");
      const that = this;
      this.removeInactivityTimeout();

      this.inactivityTimer = setTimeout(() => {
        this.iviewMessage.warning(that.$t("mindmap.beforeDispoeHint"));

        clearTimeout(this.warningTimer); // 这里再次清除，防止重复触发
        this.warningTimer = setTimeout(() => {
          this.logout();
          this.removeInactivityTimeout();
          this.unbindInactivityEvents();
          this.showRefreshHint = true;
        }, 60 * 1000); // 1分钟
      }, 10 * 60 * 1000); // 10分鐘
    },

    async setOpenCowork() {
      try {

        this.currentMindMapURL = "";
        const origData = `${window.location.origin}/MindMapClone?id=${this.currentMindMapInfo.id}`;
        // 更新 UI 狀態
        this.currentMindMapInfo.openCowork = true;

        this.selfEditMode = false;
        this.coworkMode = this.$refs.coworkModeSelect.currentSelect === this.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit";

        let fluidCoworkModeData = JSON.stringify({
          openCowork: true,
          coworkMode: this.$refs.coworkModeSelect.currentSelect === this.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit",
        });

        const data = {
          "origDataList": [{ "origData": origData }],
          "type": "cardcollect",
          "useShortDigits": false,
          "isPermanent": false,
          "lang": this.$i18n.locale.toLowerCase(),
          "note": JSON.stringify({mindmapName:this.currentMindMapInfo.mindmapName})
        };

        const res = await api.mindmapAPI.getClipCode(data);
        const clipCode = res.clipCodePairs[0].clipCode;

        // 將設定寫回 API
        await api.mindmapAPI.updateMindMap({
          id: this.currentMindMapInfo.id,
          mindmapEditor: {
            id: this.currentMindMapInfo.mindmapEditor.id,
            name: this.currentMindMapInfo.mindmapEditor.name,
          },
          openCowork: true,
          coworkMode: this.$refs.coworkModeSelect.currentSelect === this.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit",
          urlClipCode: clipCode
        });
        this.currentMindMapURL = clipCode;

        this.setFluidCoworkMode(fluidCoworkModeData);
      } catch (error) {
        console.error("開啟協作模式失敗:", error);
      }
    },

    async closeOpenCowork() {
      try {
        // 將設定寫回 API
        await api.mindmapAPI.updateMindMap({
          id: this.currentMindMapInfo.id,
          mindmapEditor: {
            id: this.currentMindMapInfo.mindmapEditor.id,
            name: this.currentMindMapInfo.mindmapEditor.name,
          },
          openCowork: false,
        });

        // 更新 UI 狀態
        this.currentMindMapInfo.openCowork = false;
        this.selfEditMode = true;

        let fluidCoworkModeData = JSON.stringify({
          openCowork: false,
          coworkMode: this.$refs.coworkModeSelect.currentSelect === this.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit",
        });
        this.setFluidCoworkMode(fluidCoworkModeData);
      } catch (error) {
        console.error("關閉協作模式失敗:", error);
      }
    },
    async saveEnterMindHistory(mindmap) {
      if (!mindmap || !this.profile.teammodelId) return;
      
      const storageKey = `enterMindHistory_${this.profile.teammodelId}`;
      let histories = JSON.parse(localStorage.getItem(storageKey) || '[]');
      
      // 查找現有記錄以保留 isFavorite 狀態
      const existingHistory = histories.find(h => h.id === mindmap.id);
      
      const history = {
        id: mindmap.id,
        mindmapName: mindmap.mindmapName,
        snapshotUrl: mindmap.snapshotUrl,
        timestamp: Date.now(),
        mindmapCreator: {
          id: mindmap.mindmapCreator.id,
          name: mindmap.mindmapCreator.name
        },
        // 保留現有的 isFavorite 狀態，預設為 false
        isFavorite: existingHistory?.isFavorite || false
      };

      // 移除相同 id 的舊記錄
      histories = histories.filter(h => h.id !== history.id);

      // 新增到開頭
      histories.unshift(history);

      // 限制最多保存 100 筆，優先保留有星號的項目
      if (histories.length > 100) {
        // 分離有星號和沒星號的項目
        const favoriteItems = histories.filter(h => h.isFavorite);
        const nonFavoriteItems = histories.filter(h => !h.isFavorite);
        
        // 計算需要保留的項目數量
        if (favoriteItems.length >= 100) {
          // 如果星號項目就超過 100 筆，只保留最新的 100 筆星號項目
          histories = favoriteItems.slice(0, 100);
        } else {
          // 保留所有星號項目，再從非星號項目中保留最新的項目湊滿 100 筆
          const remainingSlots = 100 - favoriteItems.length;
          const selectedNonFavorites = nonFavoriteItems.slice(0, remainingSlots);
          histories = [...favoriteItems, ...selectedNonFavorites];
          // 重新按時間排序
          histories.sort((a, b) => b.timestamp - a.timestamp);
        }
      }

      localStorage.setItem(storageKey, JSON.stringify(histories));
      Object.assign(this.enterMindHistory, histories);
    },
    async saveCoworkMode() {
      try {
        // 將設定寫回 API
        await api.mindmapAPI.updateMindMap({
          id: this.currentMindMapInfo.id,
          mindmapEditor: {
            id: this.currentMindMapInfo.mindmapEditor.id,
            name: this.currentMindMapInfo.mindmapEditor.name,
          },
          coworkMode: this.$refs.coworkModeSelect.currentSelect === this.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit",
        });
        this.currentMindMapInfo.coworkMode = this.$refs.coworkModeSelect.currentSelect === this.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit";
        this.coworkMode = this.$refs.coworkModeSelect.currentSelect === this.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit";

        console.log(this.fluidCoworkMode, "fluidCoworkMode");

        let fluidCoworkModeData = JSON.stringify({
          openCowork: this.currentMindMapInfo.openCowork,
          coworkMode: this.$refs.coworkModeSelect.currentSelect === this.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit",
        });

        this.setFluidCoworkMode(fluidCoworkModeData);

        this.closeShareLinkBox();
        this.iviewMessage.info(this.$t("mindmap.mindmapHome.saveOk"));
      } catch (error) {
        console.error("儲存失敗：", error);
      }
    },
    closeShareLinkBox() {
      // 檢查標題是否有變更，如果有則儲存
      if (this.titleEditVal && this.titleEditVal !== this.currentMindMapInfo.mindmapName && this.titleEditVal.trim() !== '') {
        this.saveTitleEdit();
      }
      this.showShareLinkBox = false;
    },
    resetTitleEdit() {
      this.titleEditVal = this.currentMindMapInfo.mindmapName;
    },
    async saveTitleEdit() {
      try {
        // 將設定寫回 API
        await api.mindmapAPI.updateMindMap({
          mindmapName: this.titleEditVal,
          id: this.currentMindMapInfo.id,
          mindmapEditor: {
            id: this.currentMindMapInfo.mindmapEditor.id,
            name: this.currentMindMapInfo.mindmapEditor.name,
          },
        });
        this.currentMindMapInfo.mindmapName = this.titleEditVal;
        this.currentMindmapName = this.titleEditVal;
        this.iviewMessage.info(this.$t("mindmap.saveOK"));
      } catch (error) {
        this.iviewMessage.error(this.$t("mindmap.saveFailed"), error);
      }
    },
    async publishAsAssignmentTemplate() {
      if (!this.isLogin) {
        this.iviewMessage.error('請先登入才能發布作業任務');
        return;
      }

      // 先關閉分享窗格
      this.closeShareLinkBox();

      this.$q.loading.show({
        message: this.$t("mindmap.mindmapHome.initialize")
      });

      try {
        // 獲取當前心智圖的資訊
        const currentMindMap = this.currentMindMapInfo;
        if (!currentMindMap || !currentMindMap.fluidContainerId) {
          throw new Error('無法獲取當前心智圖資訊');
        }

        // 創建作業任務
        await this.createMindCollectFromTemplate(currentMindMap);

        this.$q.loading.hide();
        this.iviewMessage.success('心智圖作業任務創建成功！');
        
      } catch (error) {
        this.$q.loading.hide();
        console.error("創建心智圖作業任務失敗：", error);
        this.iviewMessage.error('創建失敗，請稍後再試');
      }
    },
    openShareLinkBox() {
      if(!this.isCreator) return;
      if (this.currentMindMapInfo.openCowork) {
        this.currentMindMapURL = this.currentMindMapInfo.urlClipCode;
      }
      this.$refs.coworkModeSelect.currentSelect = this.currentMindMapInfo.coworkMode === "view" ? this.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") : this.$t("mindmap.mindmapHome.coworkModeNoteText.editLongVer");
      this.titleEditVal = this.currentMindMapInfo.mindmapName;
      this.showShareLinkBox = true;
      this.showMainMenu = false;
    },
    async initializeAuth() {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("auth_token_expiry");
      try {
          const res = await api.main.getTokenUnlogin();
          const exp = jwt_decode(res.auth_token).exp;
          localStorage.setItem("auth_token", res.auth_token);
          localStorage.setItem("auth_token_expiry", exp);
      } catch (error) {
        console.error("Error fetching auth token ", error);
      }
    },
    decryptData(encryptedData, key) {
      const decrypted = CryptoJS.AES.decrypt(decodeURIComponent(encryptedData), key);
      return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    },
    async handleLoginAndProfile() {
      const url = new URL(window.location.href);
      const queryParams = new URLSearchParams(url.search);
      const code = queryParams.get("code") || "";
      const webIRstuInfo = queryParams.get("webIRSstuInfo");
      const isInCollec = this.currentMindMapInfo?.collectId && this.currentMindMapInfo?.collectId !== "";
      const languageParam = queryParams.get("l");
      if(isInCollec){
        this.isInCollect = true;
        this.collectIdType = this.currentMindMapInfo?.collectIdType || "task";
      }
      if (isInCollec&&this.collectIdType==="task") {

        //作業區文件，採編輯代碼的方式
        if (sessionStorage.getItem("mindSubCreator")) {

          //初次匿名登入就把id 登入移除
          localStorage.removeItem("access_token");
          localStorage.removeItem("expires_in");
          localStorage.removeItem("profile");

          const mindSubCreator = JSON.parse(sessionStorage.getItem("mindSubCreator"));
          this.iviewMessage.info({
            content: this.$t("mindmap.writeDownEditKey") + "&nbsp;&nbsp;<strong>" + jsFn.decrypt(this.currentMindMapInfo.mindSubCreatorEditKey) + "</strong>",
            duration: 100,
            closable: true,
          });

          // 同時保存到本地存儲，以便下次訪問時使用
          this.saveEditKeyToLocal();

          this.isLogin = false;
          this.anonymousSeat = mindSubCreator.id;
          this.anonymousTempName = mindSubCreator.id + " " + mindSubCreator.name;
          this.currentAnonymousTempName = this.anonymousTempName;
          sessionStorage.setItem("anonymousSeat", this.anonymousSeat);
          sessionStorage.setItem("currentAnonymousTempName", this.currentAnonymousTempName);
          sessionStorage.removeItem("mindSubCreator");
          this.initMindMap();
        } else {


          if (code) {
            this.isLogin = true;
            const res = await api.main.getToken();
            localStorage.setItem("id_token", res.id_token);
            const decoded = jwt_decode(res.id_token);

            Object.assign(this.profile, {
              name: decoded.name,
              teammodelId: decoded.sub,
              picture: decoded.picture,
            });

            localStorage.setItem("access_token", res.access_token);
            localStorage.setItem("expires_in", res.expires_in);
            localStorage.setItem("profile", JSON.stringify(this.profile));

            // 處理語系切換
            if (languageParam) {
              this.handleLanguageSwitch(languageParam);
            }

            // Remove the code and l parameters from the URL
            const url = new URL(window.location.href);
            url.searchParams.delete("code");
            if (languageParam) {
              url.searchParams.delete("l");
            }
            window.history.replaceState({}, document.title, url.toString());
          }
          else if (localStorage.getItem("profile") && localStorage.getItem("access_token")) {
            this.isLogin = true;
            const profile = JSON.parse(localStorage.getItem("profile"));
            Object.assign(this.profile, {
              teammodelId: profile.id || profile.teammodelId,
              name: profile.name,
              picture: profile.picture,
            });
          }

          const res = await api.mindmapAPI.getMindCollectById({ cid: this.currentMindMapInfo.collectId, returnMindMapList: false });

          this.mindCollecInfo = res.mindCollect;
          this.isCreator = this.currentMindMapInfo.mindmapCreator.id == this.fromInfo?.seat;


          //先確定這個作業區目前相關狀態，讓直接從連結進入者判斷 是否為允許別人觀看 和現在是否可以繳交的狀態
          //不能繳交，直接結束
          if (!this.mindCollecInfo.openSubmit) {
            this.showForbiddenCollect = true;
            this.iviewMessage.info(this.$t("mindmap.mindCollectPage.submitClose"));
            this.initMindMap();
            this.coworkMode = "view";
            return
          }

          if (this.mindCollecInfo.allowViewOthers && !this.isCreator) { //允許別人看的話，初始化後強制改為唯讀模式 編輯表單要在裡面做按鈕
            this.initMindMap();
            // 先檢查本地存儲，如果沒有再檢查 session
            this.coworkMode = this.checkLocalEditKey() || this.checkSessionEditKey() ? "edit" : "view";
            this.selfEditMode = false;
          }

          else if (!this.mindCollecInfo.allowViewOthers && !this.isCreator) { //不允別人看的作業區直接屏蔽，顯示表單
            // 先檢查本地存儲，如果沒有再檢查 session
            if (!this.checkLocalEditKey() && !this.checkSessionEditKey()) {
              this.showNotAllowView = true;
            } else {
              this.initMindMap();
              this.coworkMode = "edit";
            }

          } else {
            this.initMindMap();
          }

        }
      } else {
        if (this.handleLoggedInUser()) return;
        if (code) {
          await this.fetchTokenAndProfile();
          return;
        }
        if (webIRstuInfo) {
          this.handleAnonymousLogin(webIRstuInfo);
          return;
        }

        this.handleAnonymousMode();
      }
    },

    /** 已登入使用者的處理 */
    handleLoggedInUser() {
      if (localStorage.getItem("profile") && localStorage.getItem("access_token")) {
        this.isLogin = true;
        const profile = JSON.parse(localStorage.getItem("profile"));
        Object.assign(this.profile, {
          teammodelId: profile.id || profile.teammodelId,
          name: profile.name,
          picture: profile.picture,
        });
        this.initMindMap();
        return true;
      }
      return false;
    },

    /** OAuth 登入 */
    async handleOAuthLogin(code) {
      if (!code) return false;

      this.isLogin = true;
      const res = await api.main.getToken();
      localStorage.setItem("id_token", res.id_token);
      const decoded = jwt_decode(res.id_token);

      Object.assign(this.profile, {
        name: decoded.name,
        teammodelId: decoded.sub,
        picture: decoded.picture,
      });

      localStorage.setItem("access_token", res.access_token);
      localStorage.setItem("expires_in", res.expires_in);
      localStorage.setItem("profile", JSON.stringify(this.profile));
      this.initMindMap();
      return true;
    },


    /** 解密登入資料 */
    async handleEncryptedLogin(encryptedData, secretKey) {
      this.$q.loading.show();
      this.isLogin = true;
      sessionStorage.clear();

      const res = this.decryptData(encryptedData, secretKey);
      const decoded = jwt_decode(res.id_Token);

      localStorage.setItem("profile", JSON.stringify({
        name: decoded.name,
        teammodelId: decoded.sub,
        picture: decoded.picture,
      }));

      Object.assign(this.profile, {
        name: decoded.name,
        teammodelId: decoded.sub,
        picture: decoded.picture,
      });

      sessionStorage.setItem("jumpFrom", res?.from);
      localStorage.setItem("id_token", res.id_Token);
      localStorage.setItem("access_token", res.access_Token);
     localStorage.setItem("expires_in", res.expires_in);

      this.initMindMap();
    },

    /** 處理匿名登入 */
    handleAnonymousLogin(webIRstuInfo) {
      this.isLogin = false;
      const res = this.decryptData(webIRstuInfo, "fromWebIRS");
      this.anonymousTempName = `${res.seat} ${res.name}`;
      this.saveAnonymousName();
    },

    /** 處理匿名模式 */
    handleAnonymousMode() {
      this.isLogin = false;
      this.showAnonymousNameBox = true;
      const tempName = sessionStorage.getItem("currentAnonymousTempName");
      if (tempName) {
        this.currentAnonymousTempName = tempName;
        this.anonymousTempName = tempName;
      }
      localStorage.removeItem("profile");
    },

    async fetchTokenAndProfile() {
      try {
        const res = await api.main.getToken();
        localStorage.setItem("id_token", res.id_token);
        const decoded = jwt_decode(res.id_token);

        Object.assign(this.profile, {
          name: decoded.name,
          teammodelId: decoded.sub,
          picture: decoded.picture,
        });

        localStorage.setItem("access_token", res.access_token);
        localStorage.setItem("expires_in", res.expires_in);
        localStorage.setItem("profile", JSON.stringify(this.profile));

        // Remove the code parameter from the URL
        const url = new URL(window.location.href);
        url.searchParams.delete("code");
        window.history.replaceState({}, document.title, url.toString());
        
        this.initMindMap();
      } catch (err) {
        console.error(err);
      }
    },

    setupMindMapEventListeners() {
      const jmDom = document.getElementById("jsmind_container");

      jmDom.addEventListener("drag_start", (event) => {
        this.showNameLabel = false;
      });
        

      // 監聽拖曳結束事件，更新 fluid relay
      jmDom.addEventListener("drag_end", (event) => {
        const node = event.detail.node;
        node.data.finalAction = "update";
        if (node) {
          // console.log("節點拖曳結束，更新 fluid relay", node);
          // 使用 setFluidMindNodeData 更新 fluid relay
          this.setFluidMindNodeData(node);
          
          // 更新同層級所有兄弟節點的索引
          if (node.parent) {
            const parentNode = node.parent;
            // 確保所有兄弟節點的索引與視覺順序一致
            parentNode.children.forEach((child, index) => {
              // 更新子節點的索引
              child.index = index;
              // 將更新後的節點同步到 fluid relay
              this.setFluidMindNodeData(toRaw(child));
            });
          }
        }
      });

      // 監聽節點無法移動事件（嘗試將節點拖曳到自己的子節點）
      jmDom.addEventListener("node_cannot_move", (event) => {
        const detail = event.detail;
        if (detail && detail.reason === "cannot_move_to_child") {
          // 使用 iviewMessage 顯示多語系錯誤訊息
          this.iviewMessage.error(this.$t("mindmap.cannotMoveToChild"));
        }
      });

      jmDom.addEventListener("contextmenu", (e) => e.preventDefault());
      jmDom.addEventListener("click", (e) => {
        // 檢查是否正在拖曳
        const isDragging = window.jsMindDragFlag?.isDragging;
        
        // 如果正在拖曳，則不處理點擊事件
        if (isDragging) {
          // console.log("拖曳中，忽略點擊");
          return;
        }
        
        // 檢查最後拖曳結束時間
        if (window.jsMindDragFlag && window.jsMindDragFlag.lastDragEndTime > 0) {
          const now = new Date().getTime();
          const timeSinceDragEnd = now - window.jsMindDragFlag.lastDragEndTime;
          
          // 如果在300毫秒內，則忽略點擊
          if (timeSinceDragEnd < 300) {
            // console.log("拖曳剛結束，忽略點擊", timeSinceDragEnd);
            return;
          }
        }
        
        // 處理圖片點擊事件
        if (e.target.className === "mindmap-img" && e.target?.src) {
          e.stopPropagation(); // 阻止事件冒泡，避免觸發節點選擇
          this.viewBigImg(e.target.src);
          return; // 圖片點擊後不再處理其他邏輯
        }
        
        // 只有在點擊節點元素時才處理節點選擇
        const targetElement = e.target;
        const isNodeElement = targetElement.tagName.toLowerCase() === 'jmnode' || 
                             targetElement.closest('jmnode') !== null;
        
        // 判斷是否點擊的是節點選單內容
        const isClickingMenu = e.target.closest('.mindmap-menu') !== null;
        
        // 如果點擊的是節點元素，則處理節點選單
        if (isNodeElement) {
          this.handleNodeMenu(e);
        } 
        // 如果點擊的不是節點元素也不是選單內容，則關閉選單
        else if (!isClickingMenu && this.showNodeMenu) {
          this.showNodeMenu = false;
          this.showSelectedNote = false;
        }
      });
      
      // 添加對整個文檔的點擊事件監聽，關閉節點選單
      document.addEventListener("click", (e) => {
        // 如果點擊的不是思維圖元素也不是選單元素
        const isClickingMindmap = e.target.closest('#jsmind_container') !== null;
        const isClickingMenu = e.target.closest('.mindmap-menu') !== null;
        
        if (!isClickingMindmap && !isClickingMenu && this.showNodeMenu) {
          this.showNodeMenu = false;
          this.showSelectedNote = false;
        }
      });
      
      jmDom.addEventListener("dblclick", this.handleEdit);
      document.addEventListener("keyup", (e) => {
        if (this.showAddNoteTool && e.key === "Enter") {
          this.confirm();
        }
      });
    },

    setupMouseEvents() {
      const jmDom = document.getElementById("jsmind_container");
      const scrollFactor = 1;
      let startX, startY;

      jmDom.addEventListener("mousedown", (event) => {
        event.preventDefault();
        startX = event.clientX;
        startY = event.clientY;

        const onMouseMove = (event) => {
          // 如果正在拖曳節點，則不執行平移
          const isDragging = window.jsMindDragFlag?.isDragging;
          if (isDragging) {
            return;
          }
          
          const deltaX = event.clientX - startX;
          const deltaY = event.clientY - startY;
          const jmInner = jmDom.querySelector(".jsmind-inner");
          if (!jmInner) return
          jmInner.scrollLeft -= deltaX * scrollFactor;
          jmInner.scrollTop -= deltaY * scrollFactor;
          startX = event.clientX;
          startY = event.clientY;
        };

        const onMouseUp = () => {
          document.removeEventListener("mousemove", onMouseMove);
          document.removeEventListener("mouseup", onMouseUp);
        };

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      });
    },

    startAutoSave() {
      const snapshotInterval = 10 * 60 * 1000; // 10 分钟
      const tolerance = 60 * 1000; // 1 分钟
      let accumulatedTime = 0;

      this.autoSaveIntervalId = setInterval(async () => {
        if (!this.selfEditMode && (this.isNotLeader() || (this.coworkMode === "view" && !this.isCreator))) {
          return;
        }

        if (this.isModified && this.isLogin) {
          const lastSnapTime = this.currentMindMapInfo.uptSnapShotTime;
          const currentTime = Date.now();

          if (lastSnapTime && accumulatedTime !== 0 && Math.abs((accumulatedTime % snapshotInterval) - snapshotInterval) < tolerance) {
            if (Math.abs(currentTime - lastSnapTime * 1000) >= snapshotInterval) {
              await this.saveMindMapSnapshot();
            }
          }
        }

        if (this.isNoSnapShot && this.isLogin) {
          await this.saveMindMapSnapshot();
          this.isNoSnapShot = false;
        }

        accumulatedTime += 10000;
      }, 10000);
    },

    isNotLeader() {
      return this.coworkMode === "edit" && this.coworkLeader?.value?.id !== this.fromInfo.seat;
    },

    hideNameLabel() {
      this.currentNameLabel = ""; // 清空當前標籤內容
      // 獲取所有 .mindmap-name-label 元素並移除它們
      const nameLabels = document.querySelectorAll(".mindmap-name-label");
      nameLabels?.forEach((label) => {
        label.remove();
      });
    },
    toggleNodeLock() {
      this.currentNode = this.jm.get_selected_node();
      if (!this.currentNode) {
        this.iviewMessage.info(this.$t("mindmap.請先選取節點"));
        return;
      }
      console.log(this.currentNode.data);

      this.isCurrentNodeLock = !this.currentNode.data?.lock;

      this.currentLineColor = this.currentNode.data?.lineColor;
      this.currentNodeColor = this.currentNode.data?.["background-color"];

      let tempDiv = document.createElement("div");
      tempDiv.innerHTML = this.currentNode.topic;
      let filteredString = tempDiv.querySelector("p").textContent;
      this.nodeText = filteredString;
      let imgElement = tempDiv.querySelector("img");
      // 獲取圖片的 src 屬性值
      this.currentImgUrl = imgElement ? imgElement.src : "";

      let urlElement = tempDiv.querySelector("a");
      this.nodeTextURL = urlElement ? urlElement.href : "";
      this.nodeTextURLName = urlElement ? urlElement.textContent : "";
      this.isCurrentSelectRoot = false;
      this.nodeTextNote = toRaw(this.currentNode?.data)?.note || "";

      let itemInfo = {
        fromInfo: this.fromInfo,
        note: this.nodeTextNote,
        lineColor: this.currentLineColor,
        "background-color": this.currentNodeColor, //按照jsMind套件中的命名
        nodeText: this.nodeText,
        nodeImg: "",
        nodeLink: "",
        lock: this.isCurrentNodeLock,
      };

      let itemContent = `<p>${this.nodeText}</p>`;
      if (this.currentImgUrl != "") {
        itemContent += `<img class='mindmap-img' src="${this.currentImgUrl}"/><br>`;
        itemInfo.nodeImg = this.currentImgUrl;
      }

      if (this.nodeTextURL.trim() != "") {
        let url = this.fixURL(this.nodeTextURL);
        itemContent += `<a class="node-url" target="_blank" href="${url}">${this.jmNodeAttechIcon}</a>`;
        itemInfo.nodeLink = url;
      }

      this.jm.enable_edit(); //啟用編輯
      if (this.jm.get_node(this.currentNode.id)) {
        this.jm.update_node(this.currentNode.id, itemContent, itemInfo);
        let item = {
          nodeID: this.currentNode.id,
          nodeContent: itemContent,
          ...itemInfo,
        };
        this.setFluidMindHistory("update", item, "update");
        this.setFluidMindNodeData(toRaw(this.jm.get_node(this.currentNode.id)));
      }

      // 關閉選單
      this.showNodeMenu = false;
    },
    applyNodeColor() {
      // 取得選中的節點
      const selectedNode = this.jm.get_selected_node();
      if (!selectedNode) {
        this.iviewMessage.info(this.$t("mindmap.請先選取節點"));
        return;
      }

      // 取得該節點的顏色設定
      const parentLineColor = selectedNode.data?.lineColor || this.currentLineColor;
      const parentNodeColor = selectedNode.data?.["background-color"] || this.currentNodeColor;

      // 遞迴函數：套用顏色到所有子節點
      const applyColorToChildren = (node) => {
        if (!node.children || node.children.length === 0) {
          return;
        }

        node.children.forEach((child) => {
          // 更新子節點的顏色
          const updatedData = {
            ...child.data,
            lineColor: parentLineColor,
            "background-color": parentNodeColor,
            fromInfo: this.fromInfo,
          };

          // 使用 jsMind 的 update_node 方法更新節點
          this.jm.update_node(child.id, child.topic, updatedData);

          // 同步到 Fluid Relay
          this.setFluidMindNodeData(toRaw(this.jm.get_node(child.id)));

          // 遞迴處理子節點的子節點
          applyColorToChildren(child);
        });
      };

      // 開始套用顏色
      applyColorToChildren(selectedNode);

      // 關閉選單
      this.showNodeMenu = false;
      this.isModified = true;

      // 顯示成功訊息
      this.iviewMessage.success(this.$t("mindmap.menu.applyColorSuccess"));
    },
    applyAllRightLayout() {
      // 取得根節點
      const rootNode = this.jm.get_selected_node();
      if (!rootNode || rootNode.id !== 'root') {
        this.iviewMessage.info(this.$t("mindmap.請先選取節點"));
        return;
      }

      // 檢查根節點是否有子節點
      if (!rootNode.children || rootNode.children.length === 0) {
        this.iviewMessage.info(this.$t("mindmap.menu.noChildrenToApply"));
        return;
      }

      // 先收集所有第一層子節點的 ID（避免在迭代時修改陣列）
      const childIds = rootNode.children.map(child => child.id);

      // 將所有第一層子節點的 direction 改為 right (1)
      childIds.forEach((childId) => {
        const childNode = this.jm.get_node(childId);
        if (childNode) {
          // 設定 direction 為 1 (右邊)
          childNode.direction = 1;

          // 使用 jsMind 的 move_node 方法來更新節點位置和 direction
          this.jm.move_node(childId, "_last_", rootNode.id, 1);

          // 同步到 Fluid Relay
          this.setFluidMindNodeData(toRaw(this.jm.get_node(childId)));
        }
      });

      // 重新佈局以確保所有節點正確顯示
      setTimeout(() => {
        this.jm.view.relayout();
      }, 100);

      // 關閉選單
      this.showNodeMenu = false;
      this.isModified = true;

      // 顯示成功訊息
      this.iviewMessage.success(this.$t("mindmap.menu.allRightLayoutSuccess"));
    },
    applyAllLeftLayout() {
      // 取得根節點
      const rootNode = this.jm.get_selected_node();
      if (!rootNode || rootNode.id !== 'root') {
        this.iviewMessage.info(this.$t("mindmap.請先選取節點"));
        return;
      }

      // 檢查根節點是否有子節點
      if (!rootNode.children || rootNode.children.length === 0) {
        this.iviewMessage.info(this.$t("mindmap.menu.noChildrenToApply"));
        return;
      }

      // 先收集所有第一層子節點的 ID（避免在迭代時修改陣列）
      const childIds = rootNode.children.map(child => child.id);

      // 將所有第一層子節點的 direction 改為 left (-1)
      childIds.forEach((childId) => {
        const childNode = this.jm.get_node(childId);
        if (childNode) {
          // 設定 direction 為 -1 (左邊)
          childNode.direction = -1;

          // 使用 jsMind 的 move_node 方法來更新節點位置和 direction
          this.jm.move_node(childId, "_last_", rootNode.id, -1);

          // 同步到 Fluid Relay
          this.setFluidMindNodeData(toRaw(this.jm.get_node(childId)));
        }
      });

      // 重新佈局以確保所有節點正確顯示
      setTimeout(() => {
        this.jm.view.relayout();
      }, 100);

      // 關閉選單
      this.showNodeMenu = false;
      this.isModified = true;

      // 顯示成功訊息
      this.iviewMessage.success(this.$t("mindmap.menu.allLeftLayoutSuccess"));
    },
    expandAllNodes() {
      this.jm.expand_all();
      this.jm.view.relayout();
      this.showNodeMenu = false;
      if (!this.isCreator) return;
      // 預先更新 mind.data，避免 Fluid echo 回來呼叫 jm.show() 時覆蓋掉狀態
      this.mind.data.forEach(node => { node.expanded = true; });
      // 等本地渲染完成後再發協議
      this.$nextTick(() => {
        Object.keys(this.jm.mind.nodes).forEach(nodeId => {
          const node = this.jm.get_node(nodeId);
          if (node && !node.isroot) {
            this.setFluidMindNodeData({
              ...node,
              finalAction: 'update',
              data: { ...node.data, finalAction: 'update', fromInfo: this.fromInfo }
            });
          }
        });
      });
    },
    collapseAllNodes() {
      this.jm.collapse_all();
      this.jm.view.relayout();
      this.showNodeMenu = false;
      if (!this.isCreator) return;
      // 預先更新 mind.data，避免 Fluid echo 回來呼叫 jm.show() 時覆蓋掉狀態
      this.mind.data.forEach(node => { node.expanded = false; });
      // 等本地渲染完成後再發協議
      this.$nextTick(() => {
        Object.keys(this.jm.mind.nodes).forEach(nodeId => {
          const node = this.jm.get_node(nodeId);
          if (node && !node.isroot) {
            this.setFluidMindNodeData({
              ...node,
              finalAction: 'update',
              data: { ...node.data, finalAction: 'update', fromInfo: this.fromInfo }
            });
          }
        });
      });
    },
    closeRenameBox() {
      this.showRenameBox = false;
      this.renameVal = this.currentMindmapName;
    },
    resetRename() {
      this.renameVal = this.currentMindmapName;
    },
    async saveRename() {
      try {
        // 將設定寫回 API
        await api.mindmapAPI.updateMindMap({
          mindmapName: this.renameVal,
          id: this.currentMindMapInfo.id,
          mindmapEditor: {
            id: this.currentMindMapInfo.mindmapEditor.id,
            name: this.currentMindMapInfo.mindmapEditor.name,
          },
        });
        this.currentMindmapName = this.renameVal;
        this.currentMindMapInfo.mindmapName = this.renameVal;
        this.closeRenameBox();
        this.iviewMessage.info(this.$t("mindmap.saveOK"));
      } catch (error) {
        this.iviewMessage.error(this.$t("mindmap.saveFailed"), error);
      }
    },
    closeAnonymousNameBox() {
      this.showAnonymousNameBox = false;
      this.anonymousTempName = "";
      this.initMindMap();
    },
    resetAnonymousName() {
      this.anonymousTempName = "";
    },
    saveAnonymousName() {
      this.currentAnonymousTempName = this.anonymousTempName;
      this.showAnonymousNameBox = false;
      sessionStorage.setItem("currentAnonymousTempName", this.currentAnonymousTempName);
      this.initMindMap();
    },

    getAvatar(member) {
      return member.value.additionalDetails.picture ? member.value.additionalDetails.picture : `https://${location.host}/no-image.jpg`;
    },
    async getCurrentMindMapInfo() {
      try {
        let data = { mid: this.route.query.id };
        let res = await api.mindmapAPI.getMindMapByMid(data);
        this.currentMindMapInfo = res.data;
        // 設定 currentMindMapURL 為 urlClipCode（用於非擁有者複製簡碼）
        if (this.currentMindMapInfo && this.currentMindMapInfo.urlClipCode) {
          this.currentMindMapURL = this.currentMindMapInfo.urlClipCode;
        }
        return res.data; // 返回資料供其他方法使用
      } catch (error) {
        console.error("Error fetching current mind map info:", error);
        return null;
      }
    },

    async initMindMap() {
      try {
        if (!this.currentMindMapInfo) {
          this.$q.loading.hide();
          if (window?.chrome?.webview){
            setTimeout(() => {
              window?.chrome?.webview.postMessage({
                fromSharing: true,
                action: "MindMap.NotFound",
              });
            }, 2000);
            }
        }
        if (this.currentMindMapInfo.isDeleting ) {
          if (this.route.name == "MindMap") {
            this.iviewMessage.warning({
              content: this.$t("mindmap.alreadyDeleted"),
              duration: 100,
              closable: true,
            });
            this.$q.loading.hide();

            if (window?.chrome?.webview){
              setTimeout(() => {
                window?.chrome?.webview.postMessage({
                  fromSharing: true,
                  action: "MindMap.NotFound",
                });
              }, 2000);
            }
          }
          return;
        }
        this.currentMindmapName = this.currentMindMapInfo.mindmapName;
        this.init_data();
        this.isCreator = this.currentMindMapInfo.mindmapCreator.id == this.fromInfo?.seat;
        if (!this.currentMindMapInfo.snapshotUrl) {
          this.isNoSnapShot = true;
        }

        if (!this.currentMindMapInfo.openCowork) {
          this.selfEditMode = true;
          if (!this.isCreator) {
            this.showForbidden = true;
            return;
          }
          this.iviewMessage.info(this.$t("mindmap.initializeOK"));
          if (this.currentMindMapInfo.mindmapData != "") {
            let tempData = JSON.parse(this.currentMindMapInfo.mindmapData);
            this.replaceNodeImgUrl(tempData);
            this.mind.data = tempData;
          }
          this.testFluidShareMapInMind(this.currentMindMapInfo.fluidContainerId);
        } else {
          this.selfEditMode = false;
          this.coworkMode = this.currentMindMapInfo.coworkMode;
          this.showSaveStatus = this.coworkMode == "view" && this.isCreator;
          this.testFluidShareMapInMind(this.currentMindMapInfo.fluidContainerId);
        }
           //初始化拖曳功能狀態
          setTimeout(() => {
          // 根據當前權限設置拖曳功能狀態
          this.isDraggingEnabled = this.selfEditMode || this.coworkMode !== "view" || this.isCreator;

          // 初始化 jsMind 拖曳控制器
          if (this.jm && this.jm.draggable_controller) {
            this.jm.draggable_controller.set_drag_enabled(this.isDraggingEnabled);
            // console.log('drag：', this.isDraggingEnabled ? 'on' : 'off');
          }
        }, 500); // 延遲確保 jsMind 已完全初始化
      } catch (error) {
        this.iviewMessage.warning({
          content: this.$t("mindmap.initializeFailed") + `\t` + error.message,
          duration: 100,
          closable: true
        });
      }
    },
    loginTMID() {
      api.main.loginTmdID();
    },

    /** 檢查登入狀態 */
    checkLoginStatus() {
      if (localStorage.getItem("profile") && localStorage.getItem("access_token")) {
        this.isLogin = true;
        this.showAnonymousNameBox = false; // 隱藏匿名名稱框
        const profile = JSON.parse(localStorage.getItem("profile"));
        Object.assign(this.profile, {
          teammodelId: profile.id || profile.teammodelId,
          name: profile.name,
          picture: profile.picture,
        });
        console.log("登入狀態已更新:", this.profile);
      } else {
        this.isLogin = false;
        console.log("未登入狀態");
      }
    },
    replaceNodeArrImgUrl(nodeArr) {
      nodeArr.forEach((node) => this.replaceNodeImgUrl(node));
    },
    replaceNodeImgUrl(node) {
      if (node.nodeImg) {
        let newImgBlobLink = node.nodeImg.replace(/\?sv.*$/, "") + "?" + this.mindMapStore.mindMapBlobSas;
        node.nodeImg = newImgBlobLink;
        // 如果 topic 中包含 <img> 标签，替换其中的 src URL
        if (node.topic) {
          node.topic = node.topic.replace(/(<img[^>]+src=")[^"]+("[^>]*>)/, `$1${newImgBlobLink}$2`);
        }
      }

      // 递归遍历 children 节点
      if (node.children && node.children.length > 0) {
        node.children.forEach((childNode) => this.replaceNodeImgUrl(childNode));
      }
    },

    startTokenRefreshInterval() {
      this.tokenRefreshInterval = setInterval(async () => {
        //檢查auth_token是否即將過期
        const authExpiry = localStorage.getItem("auth_token_expiry");
        const now = Date.now();
        const refreshThreshold = 10 * 1000; // 提前 10 秒刷新

        if (authExpiry) {
          const exp = authExpiry * 1000; // 将 exp 转换为毫秒
          if (exp - now < refreshThreshold) {
            localStorage.removeItem("auth_token");
            localStorage.removeItem("auth_token_expiry");
            // console.log("Auth Token is about to expire. Refreshing...");
            await this.initializeAuth();
          }
        }

        // 检查 SAS Token 是否即将过期
        const sasExpiry = sessionStorage.getItem("mindmap_sas_expiry");

        if (sasExpiry) {
          const sasExpiryMs = Date.parse(sasExpiry); // 将 ISO 格式时间解析为时间戳（毫秒）
          // console.log("Current Time:", now, "SAS Expiry Time:", sasExpiryMs);

          if (sasExpiryMs - now < refreshThreshold) {
            console.log("SAS Token is about to expire. Refreshing...");
            await this.getMindMapSas();
          }
        }
      }, 60 * 1000); // 每分检查一次
    },

    async getMindMapSas() {
      try {
        const res = await api.mindmapAPI.getMindMapSas();
        // 提取 token 并存储到 mindMapStore
        const { token, expiresOn } = res;
        this.mindMapStore.setMindMapBlobSas(token); // 存储 token

        sessionStorage.setItem("mindmap_sas_expiry", expiresOn.toString());

        this.initMindMapBlob();
      } catch (error) {
        console.error("Error fetching MindMap SAS:", error);
        // 可以根据需要添加更多错误处理逻辑
      }
    },
    async saveMindMapSnapshot() {
      let that = this;
      this.$q.loading.show({ message: this.$t("mindmap.snapshoting") });
      let jmDom = document.getElementById("jsmind_container");
      let jmnodesElement = document.querySelector("jmnodes");

      // 先将Dom放大到跟绘图区等大，再截图
      jmDom.style.height = jmnodesElement.offsetHeight + "px";
      jmDom.style.width = jmnodesElement.offsetWidth + "px";
      this.jm.resize();

      // 将异步操作封装在Promise中
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          htmlToImage
            .toPng(jmDom)
            .then(async (dataURL) => {
              try {
                let compressFile = await that.dataURLtoFile(dataURL, this.route.query.id + "-" + "snapshot.png");
                let size = parseFloat(compressFile.size / 1000000).toFixed(4);

                let res = await that.mindMapUploadFile(compressFile, true);

                console.log(size + "MB", res.url + "?" + that.mindMapStore.mindMapBlobSas);

                let data = {
                  mindmapEditor: {
                    id: this.fromInfo.seat,
                    name: this.fromInfo.name,
                  },
                  id: this.route.query.id,
                  snapshotUrl: res.name,
                };

                let res2 = await api.mindmapAPI.updateMindMap(data);

                if (res2?.updated === true) {
                  //截圖太頻繁被後端拒絕應該不需要給使用者訊息
                  if (res2?.existinMindMap) {
                    that.currentMindMapInfo = res2?.existinMindMap;
                  }
                  that.iviewMessage.success(that.$t("mindmap.updateSnapshot"));
                } else {
                  console.log(res2, "更新頻繁被拒");
                }
                // 恢复原始大小
                jmDom.style.height = "100vh";
                jmDom.style.width = "100%";
                that.jm.resize();
                that.$q.loading.hide();
                that.isModified = false;
                resolve(); // 任务完成，调用resolve
              } catch (error) {
                reject(error); // 发生错误时调用reject
              }
            })
            .catch((error) => {
              reject(error); // 捕获htmlToImage.toPng的错误
            });
        }, 200);
      });
    },
    relayout(time = 300, showLoading = false) {
      let that = this
      if (showLoading) this.$q.loading.show({ message: that.$t("mindmap.relayout") });
      setTimeout(() => {
        this.jm.show(this.jm.get_data("node_tree"));

        this.jm.view.relayout();
        if (showLoading) this.$q.loading.hide();
      }, time);
    },
    copyNode() {
      let copyTargetNode = this.jm.get_selected_node();
      if (copyTargetNode) {
        this.jm.enable_edit(); //啟用編輯
        this.showNameLabel = false;
        let itemInfo = {
          finalAction: "copy",
          fromInfo: this.fromInfo,
          note: copyTargetNode.data?.note || "",
          lineColor: copyTargetNode.data?.lineColor,
          "background-color": copyTargetNode.data?.["background-color"],
          nodeText: copyTargetNode.data?.nodeText || "",
          nodeImg: copyTargetNode.data?.nodeImg || "",
          nodeLink: copyTargetNode.data?.nodeLink || "",
        };
        let nodeID = this.genUUID();
        this.jm.insert_node_after(copyTargetNode, nodeID, copyTargetNode.topic, itemInfo, copyTargetNode.direction);
       
        this.showNodeMenu = false;

        let item = {
          direction: copyTargetNode.direction,
          beforeNodeID: copyTargetNode.id,
          nodeID: nodeID,
          nodeContent: copyTargetNode.topic,
          ...itemInfo,
        };
        this.setFluidMindHistory("copy", item, "copy");
        let parentNode = this.jm.get_node(copyTargetNode.parent.id);
        //重新校正index
        parentNode.children.forEach((child, index) => {
          child.index = index;
          this.setFluidMindNodeData(toRaw(child));
        });

        this.jm.select_clear(); //清除選中狀態，避免白色字體殘留
        this.isModified = true;
      } else {
        this.iviewMessage.info(this.$t("mindmap.請先選取節點"));
      }
    },
    setLineColor(item) {
      this.currentLineColor = item;
    },
    setNodeColor(item) {
      this.currentNodeColor = item;
    },
    reloadLayout(showLoading = true) {
      if (showLoading) this.$q.loading.show();
      setTimeout(
        () => {
          this.jm.show(this.mind);
          this.jm.view.relayout();
          if (showLoading) this.$q.loading.hide();
        },
        showLoading ? 1000 : 200
      );
    },

    resetImageUploader() {
      if (this.$refs.mainImageUploader) {
        this.$refs.mainImageUploader.value = "";
      }
      if (this.$refs.mainImageUploaderInit) {
        this.$refs.mainImageUploaderInit.value = "";
      }
    },
    openWhiteEditor() {
      this.isOverMaxImageSize = false;
      this.inputImgFileBeforeOpenCanvas = "";
      this.showImgEditor = true;
    },
    openEditor() {
      this.inputImgFileBeforeOpenCanvas = this.currentImgUrl;
      this.showImgEditor = true;
    },
    imgfileChangeHandler(e) {
      let that = this;
      this.isOverMaxImageSize = false;
      //這邊圖片直接做成上傳檔案
      let fileName = e.target.files[0].name;

      let fileReader = new FileReader();
      fileReader.readAsDataURL(e.target.files[0]);

      fileReader.onload = (e) => {
        let imageObj = new Image();
        imageObj.setAttribute("crossOrigin", "Anonymous");
        imageObj.src = e.target.result;
        imageObj.onload = async function () {
          let ratio = that.calScaleRatio(imageObj.width, imageObj.height, 1024, 1024).ratio;
          if (imageObj.width <= 1024 && imageObj.height <= 1024) ratio = 1;
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          const originalWidth = imageObj.width;
          const originalHeight = imageObj.height;
          const canvasWidth = originalWidth * ratio;
          const canvasHeight = originalHeight * ratio;
          canvas.width = canvasWidth;
          canvas.height = canvasHeight;
          context.drawImage(imageObj, 0, 0, canvasWidth, canvasHeight);
          let compressFile = await that.dataURLtoFile(canvas.toDataURL("images/jpeg", 1), fileName);
          let size = parseFloat(compressFile.size / 1000000).toFixed(4);

          if (!size) return;
          if (size > this.maxImageSize) {
            that.isOverMaxImageSize = true;
          } else {
            that.isUploadImg = true;
            that.$q.loading.show();
            that.mindMapUploadFile(compressFile).then((res) => {
              that.currentImgUrl = res.url + "?" + that.mindMapStore.mindMapBlobSas;
              that.isUploadImg = false;
              that.$q.loading.hide();
            });
          }
        };
      };
    },
    getNodePos(nodeId) {
      // 精确查找目标节点
      const node = document.querySelector(`jmnode[nodeid="${nodeId}"]`);
      if (node) {
        const styles = window.getComputedStyle(node);
        return {
          left: parseFloat(styles.left) - 15,
          top: parseFloat(styles.top) - 15,
        };
      }
      return null; // 未找到返回 null
    },
    async updateStageNode(actionItem, index = 0) {
      this.jm.enable_edit(); // 启用编辑
      this.showNameLabel = false;

      const dont_center = true;
      const item = JSON.parse(actionItem.item);

      // 初始化节点信息
      const itemInfo = {
        fromInfo: item?.fromInfo,
        note: item?.note,
        lineColor: item?.lineColor,
        "background-color": item?.["background-color"],
        nodeText: item?.nodeText || "",
        nodeImg: item?.nodeImg || "",
        nodeLink: item?.nodeLink || "",
        lock: item?.lock || false,
      };

      const nodeID = item?.nodeID;
      let itemContent = item?.nodeContent;
      const beforeNodeID = item?.beforeNodeID;
      const parentNodeID = item?.parentNodeID;
      const direction = item?.direction;

      // 等待节点加载的通用方法
      const waitForNode = async (nodeId, timeout = 4) => {
        const interval = 2; // 轮询间隔
        const maxTries = timeout / interval;
        let tries = 0;

        return new Promise((resolve, reject) => {
          const checkNode = () => {
            const node = this.jm.get_node(nodeId);
            if (node) {
              resolve(node);
            } else if (tries >= maxTries) {
              reject(new Error(`Node with ID "${nodeId}" not found within timeout.`));
            } else {
              tries++;
              setTimeout(checkNode, interval);
            }
          };
          checkNode();
        });
      };

      // 更新锁定状态
      if (this.jm.get_selected_node()?.id === nodeID) {
        this.isCurrentNodeLock = itemInfo.lock;
      }

      // 替换图片的 SAS Token
      if (itemContent && itemInfo.nodeImg) {
        const newImgBlobLink = itemInfo.nodeImg.replace(/\?sv.*$/, "") + "?" + this.mindMapStore.mindMapBlobSas;
        itemContent = itemContent.replace(/(<img[^>]+src=")[^"]+("[^>]*>)/, `$1${newImgBlobLink}$2`);
      }

      const finalizeNodeUpdate = async (node) => {
        if (this.isInitReadingFluidData) {
          await new Promise((resolve) => {
            resolve();
          });
          return; //初始化不需要一直relayout
        }
        if (node) {
          this.setCurrentNameLabel(item, node.id);
          if (!this.showNodeMenu) {
            await new Promise((resolve) => {
              setTimeout(() => {
                this.jm.show(this.jm.get_data("node_tree"), dont_center);
                this.jm.view.relayout();
                resolve(); // 标记完成
              }, 200);
            });
          }
        }
      };

      // 动作分支处理
      try {
        // console.log(`準備添加${index}`, actionItem,parentNodeID);
        switch (actionItem.action) {
          case "add": {
            const addTargetNode = await waitForNode(parentNodeID);
            if (addTargetNode && !this.jm.get_node(nodeID)) {
              this.jm.add_node(addTargetNode, nodeID, itemContent, itemInfo, direction);
              await finalizeNodeUpdate(this.jm.get_node(nodeID));
            }
            break;
          }
          case "delete": {
            const deleteTargetNode = await waitForNode(nodeID);
            if (deleteTargetNode) {
              this.jm.remove_node(deleteTargetNode);
              await finalizeNodeUpdate(deleteTargetNode);
            }
            break;
          }
          case "update": {
            const updateTargetNode = await waitForNode(nodeID);
            if (updateTargetNode) {
              // 檢查是否有展開/收合狀態變更
              let hasExpandedChange = false;
              if (item.hasOwnProperty('expanded') && item.expanded !== updateTargetNode.expanded) {
                hasExpandedChange = true;
              }

              this.jm.update_node(nodeID, itemContent, itemInfo);

              // 處理展開/收合狀態同步
              if (hasExpandedChange) {
                if (item.expanded) {
                  this.jm.expand_node(updateTargetNode);
                } else {
                  this.jm.collapse_node(updateTargetNode);
                }
                // 展開/收合操作不需要 finalizeNodeUpdate（避免畫面置中晃動）
                // expand_node/collapse_node 已經內建視覺更新
              } else {
                // 一般更新需要 finalizeNodeUpdate
                await finalizeNodeUpdate(updateTargetNode);
              }
            }
            break;
          }
          case "copy": {
            const copyTargetNode = await waitForNode(beforeNodeID);
            if (copyTargetNode && !this.jm.get_node(nodeID)) {
              this.jm.insert_node_after(copyTargetNode, nodeID, copyTargetNode.topic, itemInfo, copyTargetNode.direction);
              await finalizeNodeUpdate(this.jm.get_node(nodeID));
            }
            break;
          }
          case "moveToBottom":
          case "moveToTop": {
            const moveTargetNode = await waitForNode(nodeID);
            const preNode = await waitForNode(beforeNodeID);
            const parentNode = await waitForNode(parentNodeID);
            if (moveTargetNode && preNode && parentNode) {
              this.jm.move_node(moveTargetNode, preNode.id, parentNode.id, moveTargetNode.direction);
              const updatedNode = actionItem.action === "moveToBottom" ? preNode : moveTargetNode;
              await finalizeNodeUpdate(updatedNode);
            }
            break;
          }
          case "moveToTarget": {
            const moveTargetNode = await waitForNode(nodeID);
            const targetNode = await waitForNode(parentNodeID);
            if (moveTargetNode && targetNode) {
              this.jm.move_node(moveTargetNode, "_last_", targetNode.id);
              await finalizeNodeUpdate(moveTargetNode);
            }
            break;
          }
          case "InputMD": {
            this.jm.show(item.mind);
            break;
          }
        }
        // console.log(`完成添加${index}`, actionItem);
      } catch (error) {
        console.error("Error processing action:", actionItem.action, error);
      }
      this.isModified = true;
    },

    init_data() {
      this.jm = new jsMind(this.options);
      this.jm.show(this.mind);

      // 覆寫 toggle_node：展開時先收合所有子孫，確保一次只展開一層
      const _origToggle = this.jm.toggle_node.bind(this.jm);
      this.jm.toggle_node = (nodeOrId) => {
        const node = (nodeOrId && nodeOrId.id) ? nodeOrId : this.jm.get_node(nodeOrId);
        if (node && !node.isroot && !node.expanded) {
          // 即將展開，先將所有子孫設為收合
          const collapseDesc = (n) => {
            if (n.children) n.children.forEach(c => { c.expanded = false; collapseDesc(c); });
          };
          collapseDesc(node);
        }
        _origToggle(nodeOrId);
      };

      // 監聽節點展開/收合事件並同步到協作者（僅擁有者可發出協議）
      this.jm.add_event_listener((type, data) => {
        if (type === 1 && (data.evt === 'expand_node' || data.evt === 'collapse_node')) {
          const node = this.jm.get_node(data.node);
          if (node && !node.isroot && this.isCreator) {
            // 只有擁有者才能同步展開/收合狀態到協作者
            const nodeData = {
              ...node,
              finalAction: 'update',
              data: {
                ...node.data,
                fromInfo: this.fromInfo
              }
            };
            this.setFluidMindNodeData(nodeData);
          }
        }
      });
    },

    zoomIn: function () {
      this.jm.view.zoomIn();
    },

    zoomOut: function () {
      this.jm.view.zoomOut();
    },
    viewBigImg(url) {
      this.currentViewImg = url;
      this.showBigImg = true;
      this.showNodeMenu = false;
    },
    clickImg() {
      this.showBigImg = false;
    },
    handleEdit() {
      if (!this.selfEditMode && this.coworkMode == "view" && !this.isCreator) return;
      if (this.jm.get_selected_node() !== null && !this.isCurrentNodeLock) {
        this.isCurrentSelectRoot = this.jm.get_selected_node().isroot;
        this.isCurrentNodeCanBeDelete = this.jm.get_selected_node().children.length == 0;
        this.isCurrentNodeCanMoveUp = this.jm.find_node_before(this.jm.get_selected_node()) != null;
        this.isCurrentNodeCanMoveDown = this.jm.find_node_after(this.jm.get_selected_node()) != null;

        let tempDiv = document.createElement("div");
        tempDiv.innerHTML = this.jm.get_selected_node().topic;
        this.currentNodeHasImg = tempDiv.querySelector("img") != null;

        if (this.currentNodeHasImg) {
          this.currentImgUrl = tempDiv.querySelector("img").src;
        }

        this.nodeEditBy = this.jm.get_selected_node().data?.finalEditor ? this.jm.get_selected_node().data?.finalEditor : { seat: this.currentMindMapInfo?.mindmapCreator?.id, name: this.currentMindMapInfo?.mindmapCreator?.name };

        this.openNode("edit");
        this.showNodeMenu = false;
        this.showSelectedNote = false;
      } else {
        this.showNodeMenu = false;
        this.showSelectedNote = false;
      }
    },
    setCurrentNameLabel(item, nodeId) {
      if (item.fromInfo.seat == this.fromInfo.seat) return; //如果是自己發的就不需要再秀名牌了

      // 获取 jsmind-inner 容器
      const container = document.querySelector(".jsmind-inner");
      if (!container) return;

      // 获取节点位置
      const nodePos = this.getNodePos(nodeId);
      if (!nodePos) return;

      const nodeWidth = this.jm.get_node(nodeId)?._data.view.width || 0;

      // 计算 label 的坐标
      let nameLabelX = nodePos.left + nodeWidth - 10;
      let nameLabelY = nodePos.top;

      // 动态创建 nameLabel 元素
      let nameLabel = document.querySelector(".mindmap-name-label");
      if (!nameLabel) {
        nameLabel = document.createElement("div");
        nameLabel.className = "mindmap-name-label";
        container.appendChild(nameLabel); // 插入到容器内
      }
      // 设置标签内容和样式
      nameLabel.textContent = item?.fromInfo.seat === "wb" || item?.fromInfo?.seat.startsWith("anonymous") ? item?.fromInfo.name : `${item?.fromInfo.seat}\n${item?.fromInfo.name}`;

      nameLabel.style.position = "absolute";
      nameLabel.style.left = `${nameLabelX}px`;
      nameLabel.style.top = `${nameLabelY}px`;
      nameLabel.style.display = "block"; // 确保显示
      nameLabel.style.backgroundColor = "black";
      nameLabel.style.whiteSpace = "nowrap";
      nameLabel.style.color = "white";
      nameLabel.style.fontSize = "14px";
      nameLabel.style.display = "inline-block";
      nameLabel.style.zIndex = "1001";
      nameLabel.style.padding = "2px";
      nameLabel.style.fontWeight = "bold";
      this.showNameLabel = true;
    },
    handleNodeMenu(e) {
      if (!this.selfEditMode && this.coworkMode == "view" && !this.isCreator) return;
      if (this.jm.get_selected_node() !== null) {
        this.showNameLabel = false;
        this.isCurrentSelectRoot = this.jm.get_selected_node().isroot;
        this.isCurrentNodeLock = this.jm.get_selected_node().data?.lock;
        this.isCurrentNodeCanBeDelete = this.jm.get_selected_node().children.length == 0;
        this.isCurrentNodeCanMoveUp = this.jm.find_node_before(this.jm.get_selected_node()) != null;
        this.isCurrentNodeCanMoveDown = this.jm.find_node_after(this.jm.get_selected_node()) != null;
        this.isCurrentNodeCanMoveLeft = this.jm.get_selected_node().direction == -1 && this.jm.get_selected_node().parent.isroot;
        this.isCurrentNodeCanMoveRight = this.jm.get_selected_node().direction == 1 && this.jm.get_selected_node().parent.isroot;
        this.isCurrentNodeHasChildren = this.jm.get_selected_node().children.length > 0;

        let tempDiv = document.createElement("div");
        tempDiv.innerHTML = this.jm.get_selected_node().topic;
        this.currentNodeHasImg = tempDiv.querySelector("img") != null;

        if (this.currentNodeHasImg) {
          this.currentImgUrl = tempDiv.querySelector("img").src;
        }
        this.nodeEditBy = this.jm.get_selected_node().data?.finalEditor ? this.jm.get_selected_node().data?.finalEditor : { seat: this.currentMindMapInfo?.mindmapCreator?.id, name: this.currentMindMapInfo?.mindmapCreator?.name };

        if (this.jm.get_selected_node().data?.note) {
          this.nodeTextNote = this.jm.get_selected_node().data?.note;
          this.showSelectedNote = true;
        } else {
          this.showSelectedNote = false;
        }
        this.showNodeMenu = true;
        let viewportHeight = window.innerHeight;
        // 估計選單高度
        let estimatedMenuHeight = 350;

        // 距離底部的距離
        let distanceToBottom = viewportHeight - e.clientY;
        this.posX = e.clientX + 20;

        // 只處理下緣：如果底部空間不足，向上偏移剛好讓選單完整顯示
        if (distanceToBottom < estimatedMenuHeight) {
          // 計算需要向上移動的距離，保持靠近節點
          let offsetNeeded = estimatedMenuHeight - distanceToBottom + 10; // 加10px緩衝
          this.posY = e.clientY - offsetNeeded;
        } else {
          this.posY = e.clientY;
        }
      } else {
        this.showNodeMenu = false;
        this.showSelectedNote = false;
      }
    },
    confirm() {
      this.currentNode = this.jm.get_node(this.currentNode.id) //校正一次node，避免收到別人的訊息已被更新節點
      if (this.ctrlNodeMode == "add") {
        this.addNodeToSelectNode();
      } else if (this.ctrlNodeMode == "edit") {
        this.updateSelectNode();
      }
    },
    updateSelectNode() {
      // 獲取原始節點資料來比較變化
      const originalNode = this.jm.get_node(this.currentNode.id);
      
      let itemInfo = {
        fromInfo: this.fromInfo,
        finalAction: "update",
        note: this.nodeTextNote,
        lineColor: this.currentLineColor,
        "background-color": this.currentNodeColor, //按照jsMind套件中的命名
        nodeText: this.nodeText,
        nodeImg: "",
        nodeLink: "",
        lock: this.isCurrentNodeLock,
      };
      
      let itemContent = `<p>${this.nodeText}</p>`;
      let hasContentChange = false;
      
      // 檢查文字變化
      if (originalNode?.data?.nodeText !== this.nodeText) {
        hasContentChange = true;
      }
      
      if (this.currentImgUrl != "") {
        itemContent += `<img class='mindmap-img' src="${this.currentImgUrl}"/><br>`;
        itemInfo.nodeImg = this.currentImgUrl;
        if (originalNode?.data?.nodeImg !== this.currentImgUrl) {
          hasContentChange = true;
        }
      }
      
      if (this.nodeTextURL.trim() != "") {
        let url = this.fixURL(this.nodeTextURL);
        itemContent += `<a class="node-url" target="_blank" href="${url}">${this.jmNodeAttechIcon}</a>`;
        itemInfo.nodeLink = url;
        if (originalNode?.data?.nodeLink !== url) {
          hasContentChange = true;
        }
      }
      
      // 只有在圖片、文字、連結有變化時才設定 finalEditor
      if (hasContentChange) {
        itemInfo.finalEditor = this.fromInfo;
      }

      this.jm.enable_edit(); //啟用編輯
      if (this.jm.get_node(this.currentNode.id)) {
        let item = {
          nodeID: this.currentNode.id,
          direction: this.currentNode?.direction,
          nodeContent: itemContent,
          ...itemInfo,
        };
        this.jm.update_node(this.currentNode.id, itemContent, itemInfo);

        this.setFluidMindHistory("update", item, "update");
        this.setFluidMindNodeData(toRaw(this.jm.get_node(this.currentNode.id)));
      } else {
        this.iviewMessage.info(this.$t("mindmap.編輯失敗"));
      }

     
      this.showNodeMenu = false;
      this.showAddNoteTool = false;

      this.jm.select_clear(); //清除選中狀態，避免白色字體殘留
      this.isModified = true;
      
      // 重新啟用拖曳功能
      setTimeout(() => {
        // 確保編輯後拖曳功能仍然可用
        if (this.options.draggable) {
          this.jm.enable_edit();
        }
        // 重新綁定拖曳事件，確保編輯後拖曳功能正常
        this.setupMouseEvents();
      }, 100);
    },
    drawLines() {
      const items = this.$el.querySelectorAll(".tree-menu-item");
      const container = document.getElementById("movetool-scroll-area");
      const containerBox = container.getBoundingClientRect();

      items.forEach((item) => {
        const rect = item.getBoundingClientRect(); // 當前項目的矩形
        const parent = item.closest(".tree-menu-item-wrap"); // 找到最近的父節點

        if (!parent || !container) return;

        const parentRect = parent.getBoundingClientRect(); // 父節點的矩形
        const parentRelativeY = parentRect.top - containerBox.top; // 父節點相對於容器的Y位置
        const childRelativeY = rect.top - containerBox.top; // 當前項目相對於容器的Y位置

        // 獲取縮排距離
        const childStyle = window.getComputedStyle(item);
        let paddingLeftValue = parseInt(childStyle.paddingLeft) || 0;
        let startY = parentRelativeY; // 垂直線的起始Y座標
        let isLastChild = false; // 用於標記是否為最後一個子元素

        // 確定垂直線的起始Y座標
        const itemId = item.closest(".tree-menu").id;
        const nodeBefore = this.jm.find_node_before(itemId.slice(4));
        const nodeAfter = this.jm.find_node_after(itemId.slice(4));

        if (nodeBefore) {
          startY = document.getElementById(`mid-` + nodeBefore.id).getBoundingClientRect().top - containerBox.top;
        }

        isLastChild = !nodeAfter; // 檢查是否是最後一個子元素

        // 處理特殊情況：第1層項目或沒有前驅節點的項目
        if (paddingLeftValue == 30) {
          let notFirstChildId = this.treeMenuData.children.findIndex((i) => i.id == itemId.slice(4));
          if (notFirstChildId > 0 && !nodeBefore) {
            let nodeInArrBeforeId = this.treeMenuData.children[notFirstChildId - 1].id;
            startY = document.getElementById(`mid-` + nodeInArrBeforeId).getBoundingClientRect().top - containerBox.top + rect.height / 2;
          }
        }
        if (!nodeBefore) {
          const nodeParent = this.jm.get_node(itemId.slice(4))?.parent;
          if (nodeParent !== undefined && startY >= 0) {
            startY = document.getElementById(`mid-` + nodeParent.id).getBoundingClientRect().top - containerBox.top + rect.height / 2 - 10;
          }
        }

        // 畫垂直線和水平線
        if (paddingLeftValue != 0) {
          // 垂直線: 父節點中心到底部的線
          this.verticalLines.push({
            x1: paddingLeftValue + 35,
            y1: startY,
            y2: isLastChild ? parentRelativeY + rect.height / 2 : parentRelativeY + rect.height,
            x2: paddingLeftValue + 35,
          });

          // 水平線: 連接到子節點的水平線
          this.horizontalLines.push({
            x1: paddingLeftValue + 35,
            y1: childRelativeY + rect.height / 2,
            x2: paddingLeftValue + 55,
            y2: childRelativeY + rect.height / 2,
          });
        }
      });
    },
    closeMoveTool() {
      this.showMoveTool = false;
      this.showNodeMenu = false;
      clearTimeout(this.drawLineTimeoutId);
      this.drawLineTimeoutId = null;
    },
    confirmMoveToParent() {
      this.currentNode=this.jm.get_node(this.currentNode.id) //校正一次node，避免收到別人的訊息已被更新節點
      this.currentNode.data.finalAction = "moveToTarget";
      this.jm.enable_edit(); //啟用編輯
      this.jm.move_node(this.currentNode, "_last_", this.currentMoveTargetNode.id);
   
      this.showMoveTool = false;
      this.showNodeMenu = false;
      this.isModified = true;
      clearTimeout(this.drawLineTimeoutId);
      this.drawLineTimeoutId = null;

      let item = {
        parentNodeID: this.currentMoveTargetNode.id,
        nodeID: this.currentNode.id,
        fromInfo: this.fromInfo,
      };

      this.setFluidMindHistory("moveToTarget", item, "moveToTarget");
      this.setFluidMindNodeData(toRaw(this.jm.get_node(this.currentNode.id)));
    },
    openMoveTool() {
      this.showMoveTool = true;
      this.currentNode = this.jm.get_selected_node();
      this.currentMoveTargetNode = this.currentNode.parent;
      this.treeMenuData = this.jm.get_data("node_tree").data;
      this.$q.loading.show();
      this.verticalLines = [];
      this.horizontalLines = [];
      this.drawLineTimeoutId = setTimeout(() => {
        const container = document.getElementById("movetool-scroll-area");
        if (container) {
          container.scrollTop = 0;
          this.drawLineAreaH = container.scrollHeight;
          const targetNode = document.querySelector(".current-node-item").children[0];
          const targetNodeRect = targetNode.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          const newLeft = (targetNodeRect.left - containerRect.left + targetNodeRect.width).toString() + "px";
          const hintElement = document.getElementById("show-hint");
          if (hintElement) {
            hintElement.style.left = newLeft;
            hintElement.style.transition = "0.5s ease-in-out";
          } else {
            console.error('Element with class "current-node-item-hint" not found.');
          }
        }
        this.drawLines();
        this.$q.loading.hide();
      }, 1000);
    },
    openNode(mode) {
      this.ctrlNodeMode = mode;
      this.currentNode = this.jm.get_selected_node();
      this.showMoreSetting = false;
      if (this.currentNode) {
        if (mode === "add") {
          this.nodeText = "";
          this.currentImgUrl = "";
          this.nodeTextURL = "";
          this.nodeTextNote = "";
          this.isCurrentSelectRoot = this.currentNode.isroot;
          this.currentLineColor = this.currentNode.data?.lineColor;
          this.currentNodeColor = this.currentNode.data?.["background-color"];
        } else if (mode === "edit") {
          this.isCurrentNodePreEditByMe = this.currentNode.data?.fromInfo?.seat === this.fromInfo?.seat;
          this.currentLineColor = this.currentNode.data?.lineColor;
          this.currentNodeColor = this.currentNode.data?.["background-color"];
          let tempDiv = document.createElement("div");
          tempDiv.innerHTML = this.currentNode.topic;
          let filteredString = tempDiv.querySelector("p").textContent;
          this.nodeText = filteredString;

          let imgElement = tempDiv.querySelector("img");
          // 獲取圖片的 src 屬性值
          this.currentImgUrl = imgElement ? imgElement.src : "";

          let urlElement = tempDiv.querySelector("a");
          this.nodeTextURL = urlElement ? urlElement.href : "";

          this.isCurrentSelectRoot = false;
          this.nodeTextNote = toRaw(this.currentNode?.data)?.note || "";
        }
        this.showAddNoteTool = true;
        this.$nextTick(() => {
          document.getElementById("node-text-focus")?.focus();
          document.getElementById("node-text-focus-large")?.focus();
        });
      } else {
        this.iviewMessage.info(this.$t("mindmap.請先選取節點"));
      }
    },
    fixURL(url) {
      // 使用正則表達式檢查URL是否以"http://"或"https://"開頭
      if (!/^https?:\/\//i.test(url)) {
        // 如果沒有，添加"http://"到URL的開頭
        url = "http://" + url;
      }
      return url;
    },
    addNodeToSelectNode() {
      this.jm.enable_edit(); //啟用編輯
      let itemInfo = {
        finalEditor: this.fromInfo,
        fromInfo: this.fromInfo,
        finalAction: "add",
        note: this.nodeTextNote,
        lineColor: this.currentLineColor,
        "background-color": this.currentNodeColor, //按照jsMind套件中的命名
        nodeText: this.nodeText,
        nodeImg: "",
        nodeLink: "",
        lock: false,
      };
      let nodeID = this.genUUID();
      let itemContent = `<p>${this.nodeText}</p>`;
      if (this.currentImgUrl != "") {
        itemContent += `<img class='mindmap-img' src="${this.currentImgUrl}"/><br>`;
        itemInfo.nodeImg = this.currentImgUrl;
      }
      if (this.nodeTextURL.trim() != "") {
        let url = this.fixURL(this.nodeTextURL);
        itemContent += `<a class="node-url" target="_blank" href="${url}">${this.jmNodeAttechIcon}</a>`;
        itemInfo.nodeLink = url;
      }
      if (this.jm.get_node(this.currentNode.id) != null) {
        let item = {
          direction: this.direction,
          parentNodeID: this.currentNode.id,
          nodeID: nodeID,
          nodeContent: itemContent,
          ...itemInfo,
        };
        this.jm.add_node(this.currentNode, nodeID, itemContent, itemInfo, this.direction);

        this.setFluidMindHistory("add", item, "add");
        this.setFluidMindNodeData(toRaw(this.jm.get_node(nodeID)));
      } else {
        this.iviewMessage.info(this.$t("mindmap.新增失敗"));
      }

    
      this.showNodeMenu = false;
      this.showAddNoteTool = false;
      this.jm.select_clear(); //清除選中狀態，避免白色字體殘留
      this.isModified = true;
    },
    deleteSelectNode() {
      //僅可刪除沒有子節點的節點
      this.jm.enable_edit(); //啟用編輯

      this.currentNode = this.jm.get_selected_node();
      if (this.currentNode == null) {
        this.iviewMessage.info(this.$t("mindmap.請先選取節點"));
        return;
      }
      if (this.currentNode.children.length == 0) {
        //這樣遠端才會先顯示標籤，否則fluidrelay delete 後完全讀不到當前編輯者的名牌資料
        this.currentNode.data.finalAction = "update";
        this.currentNode.fromInfo = this.fromInfo;

        this.setFluidMindNodeData(toRaw(this.currentNode));
        let item = {
          nodeID: this.currentNode.id,
          fromInfo: this.fromInfo,
          finalAction: "delete",
        };
        this.setFluidMindHistory("delete", item, "delete");
        this.jm.remove_node(this.currentNode.id);

        let deleteNodeId = item.nodeID;
        let deleteNodeIndex = toRaw(this.mind.data).findIndex((item) => item.id == deleteNodeId);
        if (deleteNodeIndex != -1) {
          this.mind.data.splice(deleteNodeIndex, 1);
        }
        this.setFluidMindNodeData(item);
      
      } else {
        this.iviewMessage.info(this.$t("mindmap.不可刪除有子項目的節點"));
      }

      this.showNodeMenu = false;
      this.isModified = true;
    },
    genUUID() {
      let d = Date.now();
      //Performance.now() 亞毫秒級的時間戳記
      if (typeof performance !== "undefined" && typeof performance.now === "function") {
        d += performance.now();
      }
      return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        //xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      });
    },
    moveNode(type) {
      this.jm.enable_edit(); //啟用編輯
      this.currentNode = this.jm.get_selected_node();
      console.log(toRaw(this.jm.get_node(this.currentNode.id)), "提供移動節點參考");
      if (this.currentNode == null) {
        this.iviewMessage.info(this.$t("mindmap.請先選取節點"));
        return;
      }
      if (type == "up") {
        let preNode = this.jm.find_node_before(this.currentNode);
        if (preNode == null) {
          this.iviewMessage.info(this.$t("mindmap.已是最上面"));
        } else {
          this.jm.move_node(this.currentNode, preNode.id, preNode.parent.id, this.currentNode.direction);

          let item = {
            direction: this.currentNode.direction,
            parentNodeID: preNode.parent.id,
            beforeNodeID: preNode.id,
            nodeID: this.currentNode.id,
            fromInfo: this.fromInfo,
          };
          this.setFluidMindHistory("moveToTop", item, "moveToTop");

          // 交换 index
          let currentNode = this.jm.get_node(this.currentNode.id);
          [preNode.index, currentNode.index] = [currentNode.index, currentNode.index - 1];

          // 更新数据
          currentNode.data.finalAction = "update"; //名牌標籤會用到
          currentNode.data.preNodeID = preNode.id;

          this.setFluidMindNodeData(toRaw(preNode));
          this.setFluidMindNodeData(toRaw(currentNode));
        }
      } else if (type == "down") {
        let nextNode = this.jm.find_node_after(this.currentNode);
        if (nextNode == null) {
          this.iviewMessage.info(this.$t("mindmap.已是最下面"));
        } else {
          this.jm.move_node(this.currentNode, nextNode.id, this.currentNode.parent.id, this.currentNode.direction);

          let item = {
            direction: this.currentNode.direction,
            parentNodeID: this.currentNode.parent.id,
            beforeNodeID: nextNode.id,
            nodeID: this.currentNode.id,
            fromInfo: this.fromInfo,
          };
          this.setFluidMindHistory("moveToBottom", item, "moveToBottom");

          // 交换 index
          let currentNode = this.jm.get_node(this.currentNode.id);
          [currentNode.index, nextNode.index] = [nextNode.index, currentNode.index];

          // 更新数据
          currentNode.data.finalAction = "update";
          currentNode.data.nextNodeID = nextNode.id;

          this.setFluidMindNodeData(toRaw(nextNode));
          this.setFluidMindNodeData(toRaw(currentNode));
        }
      }
      else if (type == "left" || type == "right") {
        this.currentNode.direction = type == "left" ? -1 : 1;
        this.jm.move_node(this.currentNode, "_last_", this.currentNode.parent.id, this.currentNode.direction);

        let item = {
          direction: this.currentNode.direction,
          parentNodeID: this.currentNode.parent.id,
          nodeID: this.currentNode.id,
          fromInfo: this.fromInfo,
        };
        this.setFluidMindHistory(type == "left" ? "moveToLeft" : "moveToRight", item, type == "left" ? "moveToLeft" : "moveToRight");
        this.setFluidMindNodeData(toRaw(this.currentNode));
      }

      this.showNodeMenu = false;
      this.isModified = true;
    },
    isSentByMe(item) {
      return item?.from === this.fromInfo?.seat;
    },
    calScaleRatio(imgTargetWidth, imgTargetHeight, bgWidth, bgHeight) {
      let ratio = 0;
      if (imgTargetWidth > bgWidth && imgTargetHeight < bgHeight) {
        ratio = bgWidth / imgTargetWidth;
      } else if (imgTargetWidth < bgWidth && imgTargetHeight > bgHeight) {
        ratio = bgHeight / imgTargetHeight;
      } else if (imgTargetWidth < bgWidth && imgTargetHeight < bgHeight) {
        ratio = bgWidth / imgTargetWidth < bgHeight / imgTargetHeight ? bgWidth / imgTargetWidth : bgHeight / imgTargetHeight;
      } else {
        //1.判斷要縮哪一邊
        let imgWidthMinusCanvasWidth = imgTargetWidth - bgWidth;
        let imgHeightMinusCanvasHeight = imgTargetHeight - bgHeight;
        //console.log(imgWidthMinusCanvasWidth,imgHeightMinusCanvasHeight)
        if (imgWidthMinusCanvasWidth > imgHeightMinusCanvasHeight) ratio = bgWidth / imgTargetWidth;
        else {
          ratio = bgHeight / imgTargetHeight;
        }
      }
      let screenOffsetX = (imgTargetWidth * ratio - bgWidth) / 2; //整體置中與白邊的左右差距
      let screenOffsetY = (imgTargetHeight * ratio - bgHeight) / 2; //整體置中與白邊的上下差距

      let output = {
        ratio: ratio,
        screenOffsetX: screenOffsetX,
        screenOffsetY: screenOffsetY,
      };

      return output;
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    downloadMD() {
      let jmNode = this.jm.get_data("node_tree");
      //檢查根節點欄位缺失
      if (jmNode.data.id == "root") {
        if (!jmNode.data.hasOwnProperty("index") || jmNode.data?.index == undefined) jmNode.data.index = 0;
        if (!jmNode.data.hasOwnProperty("nodeImg")) jmNode.data.nodeImg = "";
        if (!jmNode.data.hasOwnProperty("nodeLink")) jmNode.data.nodeLink = "";
        if (!jmNode.data.hasOwnProperty("nodeText")) jmNode.data.nodeText = "root";
        if (!jmNode.data.hasOwnProperty("note")) jmNode.data.note = "";
      }

      let mdText = md.jsMindToMd(jmNode);
      // 創建一個 Blob 並下載為 .md 文件
      const blob = new Blob([mdText], { type: "text/markdown" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${this.currentMindmapName}.md`; // 設置下載的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 釋放 URL 資源
      URL.revokeObjectURL(url);
    },
    backCollect() {
        this.router.push({
          path: this.collectIdType === "task"?"/mindcollect":"/mindcollect_normal",
          query: {
          cid: this.currentMindMapInfo?.collectId,
        },
      });
    },
    copyMD() {
      // 獲取 MindMap 資料並轉換為 Markdown 格式
      let jmNode = this.jm.get_data("node_tree");
      //檢查根節點欄位缺失
      if (jmNode.data.id == "root") {
        if (!jmNode.data.hasOwnProperty("index") || jmNode.data?.index == undefined) jmNode.data.index = 0;
        if (!jmNode.data.hasOwnProperty("nodeImg")) jmNode.data.nodeImg = "";
        if (!jmNode.data.hasOwnProperty("nodeLink")) jmNode.data.nodeLink = "";
        if (!jmNode.data.hasOwnProperty("nodeText")) jmNode.data.nodeText = "root";
        if (!jmNode.data.hasOwnProperty("note")) jmNode.data.note = "";
      }

      let mdText = md.jsMindToMd(jmNode);

      // 創建隱藏的 textarea
      const textarea = document.createElement("textarea");
      textarea.style.position = "absolute";
      textarea.style.opacity = "0"; // 確保不可見
      textarea.value = mdText;
      document.body.appendChild(textarea);

      // 選中並複製文字
      textarea.select();
      document.execCommand("copy");

      // 移除 textarea
      document.body.removeChild(textarea);

      this.iviewMessage.info(this.$t("mindmap.mainMenu.alreadyCopied"));
    },
    async downloadImg() {
      this.$q.loading.show();
      const jmDom = document.getElementById("jsmind_container");
      const jmnodesElement = document.querySelector("jmnodes");

      try {
        // 先將Dom放大到跟繪圖區等大，再截圖
        jmDom.style.height = jmnodesElement.offsetHeight + "px";
        jmDom.style.width = jmnodesElement.offsetWidth + "px";
        this.jm.resize();

        // 等待 DOM 渲染
        await new Promise(resolve => setTimeout(resolve, 500));

        // 強制等待所有圖片載入完成並轉換為 base64（避免 CORS 問題）
        const images = Array.from(jmDom.querySelectorAll('img'));
        console.log(`找到 ${images.length} 張圖片`);

        for (const img of images) {
          // 先設定 crossOrigin 屬性（必須在重新載入前設定）
          if (!img.src.startsWith('data:image/')) {
            const originalSrc = img.src;
            img.crossOrigin = 'anonymous';

            // 如果圖片已經載入，需要重新載入才能套用 CORS 設定
            if (img.complete) {
              img.src = '';
              img.src = originalSrc;
            }
          }

          // 等待圖片載入完成
          if (!img.complete || img.naturalHeight === 0) {
            console.log(`等待圖片載入: ${img.src}`);
            await new Promise((resolve) => {
              img.onload = resolve;
              img.onerror = () => {
                console.error(`圖片載入失敗: ${img.src}`);
                resolve();
              };
              setTimeout(resolve, 5000);
            });
          }

          // 將圖片轉換為 base64
          try {
            if (!img.src.startsWith('data:image/')) {
              console.log(`處理圖片 ${images.indexOf(img) + 1}/${images.length}`);
              const canvas = document.createElement('canvas');
              canvas.width = img.naturalWidth || img.width;
              canvas.height = img.naturalHeight || img.height;

              if (canvas.width === 0 || canvas.height === 0) {
                console.warn('圖片尺寸為 0，跳過');
                // 隱藏無效的圖片元素，避免干擾截圖
                img.style.display = 'none';
                continue;
              }

              const ctx = canvas.getContext('2d');

              // 嘗試繪製圖片
              try {
                ctx.drawImage(img, 0, 0);
                const base64 = canvas.toDataURL('image/jpeg', 0.95);

                // 替換 src
                img.src = base64;
                console.log(`圖片已轉為 base64 (${canvas.width}x${canvas.height})`);
              } catch (drawError) {
                console.error('無法繪製圖片，可能是 CORS 問題:', drawError);
                // 隱藏無法處理的圖片
                img.style.display = 'none';
              }
            }
          } catch (e) {
            console.error('圖片處理失敗:', e);
            // 隱藏處理失敗的圖片
            img.style.display = 'none';
          }
        }

        console.log('所有圖片處理完成');

        // 強制瀏覽器重繪
        jmDom.style.display = 'none';
        jmDom.offsetHeight; // 觸發 reflow
        jmDom.style.display = '';

        // iPad 需要更長的等待時間讓 DOM 完全渲染
        console.log('等待 2 秒讓 DOM 完全渲染...');
        await new Promise(resolve => setTimeout(resolve, 2000));

        const options = {
          quality: 0.95,
          backgroundColor: '#ffffff',
          cacheBust: false,
          pixelRatio: 1
        };

        // 執行多次截圖直到成功（最多 3 次）
        let dataURL = null;
        let maxLength = 0;
        let bestDataURL = null;

        for (let i = 1; i <= 3; i++) {
          console.log(`第 ${i} 次截圖嘗試...`);
          const tempURL = await htmlToImage.toJpeg(jmDom, options);
          console.log(`第 ${i} 次完成，長度: ${tempURL.length}`);

          // 記錄最大的截圖（即使不夠大也保留）
          if (tempURL.length > maxLength) {
            maxLength = tempURL.length;
            bestDataURL = tempURL;
            console.log(`更新最佳截圖，長度: ${maxLength}`);
          }

          // 如果長度有增長，可能下次會更好
          if (i < 3) {
            console.log('等待 1 秒後重試...');
            await new Promise(resolve => setTimeout(resolve, 1000));
          }
        }

        dataURL = bestDataURL;
        console.log('最終使用的 dataURL 長度:', dataURL.length);

        // 基本檢查（降低門檻）
        if (!dataURL || dataURL.length < 10000) {
          console.error('截圖失敗：dataURL 太小或無效');
          throw new Error('截圖資料無效，長度: ' + (dataURL ? dataURL.length : 0));
        }

        // 在 iPad 上直接使用 dataURL，不轉換成 Blob
        const link = document.createElement('a');
        link.href = dataURL;
        link.download = `mindmap_${new Date().getTime()}.jpg`;

        // 加入到 body 並觸發點擊
        document.body.appendChild(link);

        console.log('準備觸發下載，link.href 長度:', link.href.length);
        link.click();

        console.log('下載已觸發');

        // 清理
        setTimeout(() => {
          document.body.removeChild(link);
        }, 100);

        this.$q.loading.hide();
        this.iviewMessage.info(this.$t("mindmap.downloadImageSuccess"));

      } catch (error) {
        console.error('下載圖片失敗:', error);
        this.$q.loading.hide();
        this.iviewMessage.error(this.$t("mindmap.downloadImageFailed"));
      }
    },
    resetPasteMDText() {
      this.pasteMDText = "";
    },
    pasteMD() {
      try {
        this.isLoadingMD = true;
        let mdData = this.pasteMDText;
        this.mind = md.mdToJsMind(mdData, this);

        this.jm.show(this.mind);
        this.clearFluidMindNodeData(); //先清空fluidrelay目前的資料

        const nodeArr = this.mind.data.map((item) => item.id);

        this.mind = this.jm.get_data("node_tree");
        for (let nodeID of nodeArr) {
          if (this.jm.get_node(nodeID)) {
            this.setFluidMindNodeData(toRaw(this.jm.get_node(nodeID)));
          }
        }
        this.isModified = true;
        this.showPasteMDForm = false;
      } catch (error) {
        this.iviewMessage.error(this.$t("mindmap.markDownErr"));
      } finally {
        this.isLoadingMD = false;
      }
    },
    triggerPasteMD() {
      this.showPasteMDForm = true;
      this.showMainMenu = false;
      this.pasteMDText = '';
    },
    triggerInputMD() {
      this.$refs.fileInput.value = null;
      this.$refs.fileInput.click();
    },
    InputMD(event) {
      this.isLoadingMD = true;
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const mdData = e.target.result;
          console.log(mdData); // 在這裡可以處理 Markdown 文件的內容
          this.mind = md.mdToJsMind(mdData, this);
          this.jm.show(this.mind);
          this.clearFluidMindNodeData(); //先清空fluidrelay目前的資料

          const nodeArr = this.mind.data.map((item) => item.id);

          this.mind = this.jm.get_data("node_tree");
          for (let nodeID of nodeArr) {
            if (this.jm.get_node(nodeID)) {
              this.setFluidMindNodeData(toRaw(this.jm.get_node(nodeID)));
            }
          }
          this.isModified = true;
          // this.mind = this.jm.get_data("node_tree") //需改用node_tree/mdToJsMind是node_array
          // const mdItem={
          //   fromInfo: this.fromInfo,
          //   mind: this.mind,
          // }
          // this.setFluidMindHistory("InputMD", mdItem, "InputMD"); //改採history 的動作存放

          this.isLoadingMD = false;
        };
        reader.readAsText(file);
      }
    },
    randomColor() {
      const r = Math.floor(Math.random() * 128);
      const g = Math.floor(Math.random() * 128);
      const b = Math.floor(Math.random() * 128);

      // 將 RGB 值轉換為十六進制格式
      return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
    },
    saveTokenAndProfile(res) {
      const decoded = jwt_decode(res.id_token);

      // 設定登入狀態和使用者資訊
      this.isLogin = true;
      this.profile.name = decoded.name;
      this.profile.teammodelId = decoded.sub;
      this.profile.picture = decoded.picture;

      // 儲存 token 到 sessionStorage
      localStorage.setItem("id_token", res.id_token);
      localStorage.setItem("access_token", res.access_token);
     localStorage.setItem("expires_in", res.expires_in);

      // 將使用者資料存到 localStorage
      localStorage.setItem(
        "profile",
        JSON.stringify({
          name: this.profile.name,
          teammodelId: this.profile.teammodelId,
          picture: this.profile.picture,
        })
      );
    },
    backToHome() {
      this.router.push("/MindMapHome");
    },
    openRenameBox(){
      this.showRenameBox = true;
      this.renameVal = this.currentMindmapName;
      
    },
    /** 處理語系切換 */
    handleLanguageSwitch(languageParam) {
      if (!languageParam) return;
      
      // 語系對應邏輯
      let targetLocale = null;
      const lowerParam = languageParam.toLowerCase();
      
      if (lowerParam === 'en' || lowerParam === 'en-us') {
        targetLocale = 'en-US';
      } else if (lowerParam === 'zh-cn') {
        targetLocale = 'zh-CN';
      } else if (lowerParam === 'zh-tw') {
        targetLocale = 'zh-TW';
      } else if (!lowerParam.startsWith('zh')) {
        // 非中文的其他語系都切換到英文
        targetLocale = 'en-US';
      }
      
      if (targetLocale) {
        // 切換 Vue i18n 語系
        this.$i18n.locale = targetLocale;
        localStorage.setItem('local', targetLocale);
      }
    },
    async exportStaticMindmap(){
      this.$q.loading.show();
      
      try {
        // 先檢查是否需要重新生成短網址減碼
        await this.checkAndRefreshStaticMindCodeIfNeeded();
        
        // 獲取心智圖節點樹數據
        const nodeTreeData = this.jm.get_data("node_tree");
        
        // 轉換為JSON字符串
        const jsonString = JSON.stringify(nodeTreeData, null, 2);
        
        // 創建JSON檔案名稱
        const fileName = `${this.currentMindmapName}_static.json`;
        
        // 創建File對象
        const jsonFile = new File([jsonString], fileName, {
          type: 'application/json'
        });
        
        // 上傳到Azure Blob Storage (使用固定檔名以覆蓋之前的檔案)
        this.mindMapUploadFile(jsonFile, true).then(async (result) => {
          // 生成跳轉到HTwbMind的加密連結
          const blobUrl = result.url; // 不包含SAS，避免過期
          const encryptedBlobUrl = CryptoJS.AES.encrypt(blobUrl, "mindmapBlob").toString();
          const encodedBlobUrl = encodeURIComponent(encryptedBlobUrl);
          
          // 構建跳轉URL
          const jumpUrl = `${window.location.origin}/HTwbMind?loadBlob=true&blobUrl=${encodedBlobUrl}`;
          
          // 檢查是否已有短網址減碼，如果沒有則生成新的
          if (!this.currentMindmapStaticCode) {
            await this.generateStaticMindCode(jumpUrl);
          }
          
          // 顯示靜態心智圖對話框
          this.showStaticUrlDialog = true;
          this.$q.loading.hide();
          
        }).catch((error) => {
          this.$q.loading.hide();
          this.iviewMessage.error(error.message);
        });
        
      } catch (error) {
        this.$q.loading.hide();
        this.iviewMessage.error(error.message);
      }
    },
    copyStaticUrl() {
      const fullStaticUrl = this.shortURLHost + this.currentMindmapStaticCode;
      navigator.clipboard.writeText(fullStaticUrl).then(() => {
        this.iviewMessage.success(this.$t('mindmap.staticMindmap.copied'));
      }).catch(() => {
        // 備用方案：創建臨時文本區域
        const textarea = document.createElement('textarea');
        textarea.value = fullStaticUrl;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.iviewMessage.success(this.$t('mindmap.staticMindmap.copied'));
      });
    },
    // 檢查靜態心智圖短網址減碼有效性並自動重新生成
    async checkAndRefreshStaticMindCodeIfNeeded() {
      try {
        // 從後端獲取當前心智圖資料
        const mindmapData = await this.getCurrentMindMapInfo();
        if (mindmapData && mindmapData.staticMindCode) {
          this.currentMindmapStaticCode = mindmapData.staticMindCode;
          this.currentMindmapStaticUpdateTime = mindmapData.staticMindUpdateTime;
          
          const now = Date.now();
          const ninetyDaysInMs = 90 * 24 * 60 * 60 * 1000; // 90天的毫秒數
          
          // 檢查是否超過90天或沒有更新時間
          if (!this.currentMindmapStaticUpdateTime || 
              (now - (this.currentMindmapStaticUpdateTime * 1000)) > ninetyDaysInMs) {
            // 檢查短網址減碼是否仍然有效
            await this.checkStaticCodeValidityAndRefresh();
          }
        }
      } catch (error) {
        console.error("檢查靜態心智圖短網址減碼時發生錯誤:", error);
      }
    },
    // 檢查短網址減碼有效性並重新生成（如果無效）
    async checkStaticCodeValidityAndRefresh() {
      if (!this.currentMindmapStaticCode) return;
      
      try {
        const checkData = { clipCode: this.currentMindmapStaticCode };
        await api.mindmapAPI.getOrigDataFromClipCode(checkData);
        // 短網址減碼仍有效，不需重新生成
      } catch (error) {
        if (error.response?.status === 404) {
          // 短網址減碼已失效，需要重新生成
          console.log("靜態心智圖短網址減碼已失效，需要重新生成");
          // 清空現有的減碼，讓 exportStaticMindmap 重新生成
          this.currentMindmapStaticCode = "";
          this.currentMindmapStaticUpdateTime = null;
        } else {
          console.error("檢查短網址減碼時發生錯誤:", error);
        }
      }
    },
    // 生成新的靜態心智圖短網址減碼
    async generateStaticMindCode(jumpUrl) {
      try {
        const dataForClip = {
          "origDataList": [{ "origData": jumpUrl }],
          "type": "mindmap",
          "useShortDigits": false,
          "isPermanent": false,
          "lang": this.$i18n.locale.toLowerCase(),
          "note": JSON.stringify({ mindmapName: this.currentMindmapName+"_static" })
        };
        
        const clipRes = await api.mindmapAPI.getClipCode(dataForClip);
        const newStaticCode = clipRes.clipCodePairs[0].clipCode;
        
        // 更新本地數據
        this.currentMindmapStaticCode = newStaticCode;
        this.currentMindmapStaticUpdateTime = Math.floor(Date.now() / 1000);
        
        // 更新後端資料
        await this.updateMindMapStaticCode(newStaticCode);
        
        console.log("靜態心智圖短網址減碼已生成:", newStaticCode);
        
      } catch (error) {
        console.error("生成靜態心智圖短網址減碼失敗:", error);
        throw error;
      }
    },
    // 更新後端心智圖的靜態減碼資料
    async updateMindMapStaticCode(staticCode) {
      try {
        const updateData = {
          id: this.route.query.id,
          mindmapEditor: {
            id: this.profile.teammodelId,
            name: this.profile.name
          },
          staticMindCode: staticCode
        };
        
        await api.mindmapAPI.updateMindMap(updateData);
        
      } catch (error) {
        console.error("更新後端靜態減碼資料失敗:", error);
        throw error;
      }
    }
  },
};
</script>

<style lang="less">
@import "../assets/color.less";

.ivu-message {
  z-index: 10000 !important;
}

#mindmap-img-editor {
  margin: 0 !important;
  z-index: 1010 !important;
  background: #fff !important;
  position: relative !important;

  .canvas-qcard {
    top: 0 !important;
  }

  .q-dialog__inner--minimized>div {
    max-width: none !important;
    max-height: none !important;
  }

  .q-dialog__inner {
    padding: 0 !important;
  }
}

.mindmap {
  .select-btn {
    &:focus {
      --tw-ring-color: @light-color !important;
    }

    .arrow-icon-up {
      color: @light-color !important;
    }
  }

  jmnode {
    max-width: 150px;
    font-size: 0;

    p {
      white-space: normal;
      word-break: keep-all;
      word-wrap: break-word;
      overflow-wrap: break-word;
      font-size: 16px !important;
    }

    text-align: center !important;

    .node-url {
      cursor: pointer;
      display: flex;
      align-items: center;
      /* 水平居中对齐 */
      justify-content: center;

      /* 垂直居中对齐 */
      .node-url-icon {
        margin-top: 5px;

        path {
          fill: blue !important;
        }
      }

      &:hover {
        .node-url-icon {
          path {
            fill: rgb(255, 255, 255) !important;
          }
        }
      }
    }

    .mindmap-img {
      margin: 5px 0px;
    }

    .myNoteName {
      font-size: 40px;
    }
  }
}
</style>
<style lang="less" scoped>
@import "../assets/color.less";

.showPhonetic {
  * {
    font-family: 'BpmfZihiKaiStd', sans-serif !important;
  }
}

.user-limit-indicator {
  background-color: rgba(128, 128, 128, 0.2);
  color: #666666;
  font-weight: bold;
  font-size: 0.8em;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 8px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.6; }
  100% { opacity: 1; }
}

.mobile-user-limit-indicator {
  position: fixed;
  bottom: 10px;
  left: 10px;
  background-color: rgba(128, 128, 128, 0.2);
  color: #666666;
  font-weight: bold;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 6px;
  z-index: 1000;
  animation: pulse 2s infinite;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  display: none;
}

@media (max-width: 768px) {
  .mobile-user-limit-indicator {
    display: block;
  }
  
  .user-limit-indicator {
    display: none;
  }
}

.left-hint {
  left: 10px !important;
}

.saving-hint {
  position: fixed;
  top: 45px;
  left: 80px;
  color: rgba(0, 0, 0, 0.5);
  z-index: 1002;
}

.saved-hint {
  position: fixed;
  top: 45px;
  left: 80px;
  color: @light-color;
  z-index: 1001;
}

// Import Quasar css
@import "quasar/dist/quasar.css";

svg {
  display: unset //不明被哪個套件影響;;
}

input[type="radio"],
input[type="checkbox"] {
  visibility: hidden;
  margin-left: -10px;
}


@import "../assets/mindmap.less";
</style>
